webpackJsonp([114276838955818,60335399758886],{

/***/ 204:
/***/ (function(module, exports) {

	module.exports = {"data":{"aboutMenu":{"edges":[{"node":{"pageTitle":"About Us"}},{"node":{"pageTitle":"Privacy"}},{"node":{"pageTitle":"Terms"}}]},"events":{"edges":[{"node":{"eventType":"Conferences"}},{"node":{"eventType":"Conferences"}},{"node":{"eventType":"Conferences"}},{"node":{"eventType":"Conferences"}},{"node":{"eventType":"Conferences"}},{"node":{"eventType":"Conferences"}}]},"jobs":{"edges":[{"node":{"role":"Marketing and Communications"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Development"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Business Development"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Sales"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Other"}},{"node":{"role":"Design"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Design"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Other"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Design"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Project Management"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Design"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Business Development"}},{"node":{"role":"Project Management"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Business Development"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Design"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Sales"}},{"node":{"role":"Other"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Development"}},{"node":{"role":"Other"}},{"node":{"role":"Design"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Project Management"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Design"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Project Management"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Design"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Project Management"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Project Management"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Development"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Development"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Project Management"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Sales"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Design"}},{"node":{"role":"Business Development"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Design"}},{"node":{"role":"Business Development"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Business Development"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Design"}},{"node":{"role":"Sales"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Design"}},{"node":{"role":"Business Development"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Business Development"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Development"}},{"node":{"role":"Sales"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Design"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Sales"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Design"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Project Management"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Development"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Android Developer"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Sales"}},{"node":{"role":"Business Development"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"iOS Developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Design"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Business Development"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Project Management"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Sales"}},{"node":{"role":"Project Management"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Customer Service"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Other"}},{"node":{"role":"Sales"}},{"node":{"role":"Business Intelligence"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Backend developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Design"}},{"node":{"role":"Other"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Marketing & Communication"}},{"node":{"role":"Other"}},{"node":{"role":"Full-stack developer"}},{"node":{"role":"Frontend developer"}},{"node":{"role":"Business Development"}},{"node":{"role":"Project Management"}},{"node":{"role":"Design"}}]},"partners":{"edges":[{"node":{"id":"cjnyoo7f38is40932eyoptav6","name":"Slush","link":"https://www.slush.org/","logo":{"handle":"xV7mzGYQpmiKi1XyxytO","width":1200,"height":400}}},{"node":{"id":"cjnyooslt8iyi0932wxjx1cz6","name":"NordicMade","link":null,"logo":{"handle":"O8isRRu4TFWY38VpD9Xn","width":600,"height":154}}},{"node":{"id":"cjnyopc3w8j6g0932mnm0kjx7","name":"Tech BBQ","link":"https://www.techbbq.dk/","logo":{"handle":"KkEUv1CeQ4OAzx0SIgo7","width":1200,"height":488}}},{"node":{"id":"cjnyopti08jbu0932msesijid","name":"Rising North","link":"http://www.risingnorth.org/","logo":{"handle":"OWmjVJMNTEq6buv3VG5h","width":946,"height":326}}},{"node":{"id":"cjopjww2ekilk0932rw3y7m8y","name":"Sup46","link":"http://sup46.com","logo":{"handle":"W6RouZsJTiKNUMtQqWpy","width":512,"height":512}}},{"node":{"id":"cjoxa22xrxpkg0932aiygqhsi","name":"Maria 01","link":"https://maria.io/","logo":{"handle":"RsEpVnZSdCl2eW0LjOlh","width":1000,"height":215}}},{"node":{"id":"cjoy54vig2ojx0932pjnr3tuc","name":"Icelandic Startups","link":"http://www.icelandicstartups.com/","logo":{"handle":"swtGHz1WS1C6zhYUwFfx","width":536,"height":144}}}]}},"layoutContext":{}}

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(294);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(204);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	function noop() {
	  return null;
	}
	noop.isRequired = noop;
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  disallowedIf: noopThunk,
	  elementType: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  range: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(268) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
	function testPassiveEventListeners() {
	  if (!CAN_USE_DOM) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    var noop = function noop() {};
	    window.addEventListener('testPassiveEventSupport', noop, opts);
	    window.removeEventListener('testPassiveEventSupport', noop, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!canUsePassiveEventListeners()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}
	
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	function TargetEventHandlers(target) {
	  this.target = target;
	  this.events = {};
	}
	
	TargetEventHandlers.prototype.getEventHandlers = function () {
	  function getEventHandlers(eventName, options) {
	    var key = String(eventName) + ' ' + String(eventOptionsKey(options));
	
	    if (!this.events[key]) {
	      this.events[key] = {
	        handlers: [],
	        handleEvent: undefined
	      };
	      this.events[key].nextHandlers = this.events[key].handlers;
	    }
	
	    return this.events[key];
	  }
	
	  return getEventHandlers;
	}();
	
	TargetEventHandlers.prototype.handleEvent = function () {
	  function handleEvent(eventName, options, event) {
	    var eventHandlers = this.getEventHandlers(eventName, options);
	    eventHandlers.handlers = eventHandlers.nextHandlers;
	    eventHandlers.handlers.forEach(function (handler) {
	      if (handler) {
	        // We need to check for presence here because a handler function may
	        // cause later handlers to get removed. This can happen if you for
	        // instance have a waypoint that unmounts another waypoint as part of an
	        // onEnter/onLeave handler.
	        handler(event);
	      }
	    });
	  }
	
	  return handleEvent;
	}();
	
	TargetEventHandlers.prototype.add = function () {
	  function add(eventName, listener, options) {
	    var _this = this;
	
	    // options has already been normalized at this point.
	    var eventHandlers = this.getEventHandlers(eventName, options);
	
	    ensureCanMutateNextEventHandlers(eventHandlers);
	
	    if (eventHandlers.nextHandlers.length === 0) {
	      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	    }
	
	    eventHandlers.nextHandlers.push(listener);
	
	    var isSubscribed = true;
	    var unsubscribe = function () {
	      function unsubscribe() {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	        var index = eventHandlers.nextHandlers.indexOf(listener);
	        eventHandlers.nextHandlers.splice(index, 1);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          // All event handlers have been removed, so we want to remove the event
	          // listener from the target node.
	
	          if (_this.target) {
	            // There can be a race condition where the target may no longer exist
	            // when this function is called, e.g. when a React component is
	            // unmounting. Guarding against this prevents the following error:
	            //
	            //   Cannot read property 'removeEventListener' of undefined
	            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	          }
	
	          eventHandlers.handleEvent = undefined;
	        }
	      }
	
	      return unsubscribe;
	    }();
	    return unsubscribe;
	  }
	
	  return add;
	}();
	
	var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	// eslint-disable-next-line import/prefer-default-export
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
	  }
	  var normalizedEventOptions = normalizeEventOptions(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	exports.addEventListener = addEventListener;


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(387);
	var isArguments = __webpack_require__(386);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 386:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 387:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(388);
	var foreach = __webpack_require__(405);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(389);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ 389:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(158);
	var toPrimitive = __webpack_require__(402);
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var $isNaN = __webpack_require__(248);
	var $isFinite = __webpack_require__(247);
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(246);
	var sign = __webpack_require__(250);
	var mod = __webpack_require__(249);
	var isPrimitive = __webpack_require__(400);
	var parseInteger = parseInt;
	var bind = __webpack_require__(196);
	var arraySlice = bind.call(Function.call, Array.prototype.slice);
	var strSlice = bind.call(Function.call, String.prototype.slice);
	var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(398);
	
	var hasRegExpMatcher = __webpack_require__(455);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, Number);
			if (typeof value === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = Math.floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a string');
			}
			return String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr.call(argument) !== '[object String]') {
				throw new TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: Array.isArray || function IsArray(argument) {
			return toStr.call(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: function IsExtensible(obj) {
			if (!Object.preventExtensions) { return true; }
			if (isPrimitive(obj)) {
				return false;
			}
			return Object.isExtensible(obj);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = Math.abs(argument);
			return Math.floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && Symbol.species ? C[Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new TypeError('no constructor found');
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && Symbol.species) {
					C = this.Get(C, Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = Object.getOwnPropertyDescriptor(O, P);
			var extensible = oldDesc || (typeof Object.isExtensible !== 'function' || Object.isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			Object.defineProperty(O, P, newDesc);
			return true;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new TypeError('unable to create data property');
			}
			return success;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new TypeError('Assertion failed: Type(S) is not String');
			}
			if (!this.IsInteger(index)) {
				throw new TypeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
			}
			if (index < 0 || index > MAX_SAFE_INTEGER) {
				throw new RangeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new TypeError('Assertion failed: Type(unicode) is not Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
			var first = S.charCodeAt(index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
			var second = S.charCodeAt(index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
			return index + 2;
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(396);
	var assign = __webpack_require__(246);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(248);
	var $isFinite = __webpack_require__(247);
	
	var sign = __webpack_require__(250);
	var mod = __webpack_require__(249);
	
	var IsCallable = __webpack_require__(203);
	var toPrimitive = __webpack_require__(401);
	
	var has = __webpack_require__(158);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return Number(value);
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// http://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
			// jscs:disable
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
			// jscs:enable
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(397);


/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	var has = Object.prototype.hasOwnProperty;
	module.exports = function assign(target, source) {
		if (Object.assign) {
			return Object.assign(target, source);
		}
		for (var key in source) {
			if (has.call(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),

/***/ 400:
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(251);
	
	var isCallable = __webpack_require__(203);
	
	// https://es5.github.io/#x8.12
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O, hint) {
			var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// https://es5.github.io/#x9
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
	};


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(251);
	var isCallable = __webpack_require__(203);
	var isDate = __webpack_require__(453);
	var isSymbol = __webpack_require__(456);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (PreferredType === String) {
				hint = 'string';
			} else if (PreferredType === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(406);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      transitionDelay = props.transitionDelay,
	      otherProps = _objectWithoutProperties(props, ['opacity', 'onLoad', 'transitionDelay']);
	
	  return _react2['default'].createElement('img', _extends({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      transition: 'opacity 0.5s',
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: '100%',
	      height: '100%',
	      objectFit: 'cover',
	      objectPosition: 'center'
	    }
	  }));
	};
	
	Img.defaultProps = {
	  transitionDelay: '',
	  onLoad: null
	};
	
	Img.propTypes = {
	  opacity: _propTypes2['default'].oneOf([0, 1]).isRequired,
	  transitionDelay: _propTypes2['default'].string,
	  onLoad: _propTypes2['default'].func
	};
	
	exports['default'] = Img;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Img = __webpack_require__(65);
	
	var _Img2 = _interopRequireDefault(_Img);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	if (typeof window !== 'undefined') {
	  __webpack_require__(67);
	}
	
	// Cache if we've intersected an image before so we don't
	// lazy-load & fade in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(_ref, shouldCache) {
	  var handle = _ref.handle;
	
	  if (imageCache[handle]) {
	    return true;
	  }
	  if (shouldCache) {
	    imageCache[handle] = true;
	  }
	  return false;
	};
	
	// check webp support
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== 'undefined' ? window.document.createElement('canvas') : {};
	  if (elem.getContext && elem.getContext('2d')) {
	    isWebpSupportedCache = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
	    return isWebpSupportedCache;
	  }
	  return false;
	};
	
	// Add IntersectionObserver to component
	var listeners = [];
	var io = void 0;
	var getIO = function getIO() {
	  if (typeof io === 'undefined' && typeof window !== 'undefined') {
	    io = new IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (listener) {
	          if (listener[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              // when we intersect we cache the intersecting image for subsequent mounts
	              io.unobserve(listener[0]);
	              listener[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: '200px' });
	  }
	
	  return io;
	};
	var listenToIntersections = function listenToIntersections(element, callback) {
	  getIO().observe(element);
	  listeners.push([element, callback]);
	};
	
	var bgColor = function bgColor(backgroundColor) {
	  return typeof backgroundColor === 'boolean' ? 'lightgray' : backgroundColor;
	};
	
	// We always keep the resize transform to have matching sizes + aspect ratio
	// If used with native height & width from GraphCMS it produces no transform
	var resizeImage = function resizeImage(_ref2) {
	  var width = _ref2.width,
	      height = _ref2.height,
	      fit = _ref2.fit;
	  return 'resize=w:' + String(width) + ',h:' + String(height) + ',fit:' + String(fit);
	};
	
	var compressAndWebp = function compressAndWebp(webp) {
	  return (webp ? 'output=format:webp/' : '') + 'compress';
	};
	
	var constructURL = function constructURL(handle, withWebp, baseURI) {
	  return function (resize) {
	    return function (transforms) {
	      return [baseURI, resize].concat(_toConsumableArray(transforms), [compressAndWebp(isWebpSupported() && withWebp), handle]).join('/');
	    };
	  };
	};
	
	// responsiveness transforms
	var responsiveSizes = function responsiveSizes(size) {
	  return [size / 4, size / 2, size, size * 1.5, size * 2, size * 3];
	};
	
	var getWidths = function getWidths(width, maxWidth) {
	  var sizes = responsiveSizes(maxWidth).filter(function (size) {
	    return size < width;
	  });
	  // Add the original width to ensure the largest image possible
	  // is available for small images.
	  var finalSizes = [].concat(_toConsumableArray(sizes), [width]);
	  return finalSizes;
	};
	
	var srcSet = function srcSet(srcBase, srcWidths, fit, transforms) {
	  return srcWidths.map(function (width) {
	    return String(srcBase(['resize=w:' + String(Math.floor(width)) + ',fit:' + String(fit)])(transforms)) + ' ' + String(Math.floor(width)) + 'w';
	  }).join(',\n');
	};
	
	var imgSizes = function imgSizes(maxWidth) {
	  return '(max-width: ' + String(maxWidth) + 'px) 100vw, ' + String(maxWidth) + 'px';
	};
	
	var GraphImage = function (_React$Component) {
	  _inherits(GraphImage, _React$Component);
	
	  function GraphImage(props) {
	    _classCallCheck(this, GraphImage);
	
	    var _this = _possibleConstructorReturn(this, (GraphImage.__proto__ || Object.getPrototypeOf(GraphImage)).call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== 'undefined' && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Never render image while server rendering
	    if (typeof window === 'undefined') {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    _this.onImageLoaded = _this.onImageLoaded.bind(_this);
	    return _this;
	  }
	
	  _createClass(GraphImage, [{
	    key: 'onImageLoaded',
	    value: function () {
	      function onImageLoaded() {
	        var _this2 = this;
	
	        if (this.state.IOSupported) {
	          this.setState(function () {
	            return {
	              imgLoaded: true
	            };
	          }, function () {
	            inImageCache(_this2.props.image, true);
	          });
	        }
	        if (this.props.onLoad) {
	          this.props.onLoad();
	        }
	      }
	
	      return onImageLoaded;
	    }()
	  }, {
	    key: 'handleRef',
	    value: function () {
	      function handleRef(ref) {
	        var _this3 = this;
	
	        if (this.state.IOSupported && ref) {
	          listenToIntersections(ref, function () {
	            _this3.setState({ isVisible: true, imgLoaded: false });
	          });
	        }
	      }
	
	      return handleRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            title = _props.title,
	            alt = _props.alt,
	            className = _props.className,
	            outerWrapperClassName = _props.outerWrapperClassName,
	            style = _props.style,
	            _props$image = _props.image,
	            width = _props$image.width,
	            height = _props$image.height,
	            handle = _props$image.handle,
	            fit = _props.fit,
	            maxWidth = _props.maxWidth,
	            withWebp = _props.withWebp,
	            transforms = _props.transforms,
	            blurryPlaceholder = _props.blurryPlaceholder,
	            backgroundColor = _props.backgroundColor,
	            fadeIn = _props.fadeIn,
	            baseURI = _props.baseURI;
	
	
	        if (width && height && handle) {
	          // unify after webp + blur resolved
	          var srcBase = constructURL(handle, withWebp, baseURI);
	          var thumbBase = constructURL(handle, false, baseURI);
	
	          // construct the final image url
	          var sizedSrc = srcBase(resizeImage({ width: width, height: height, fit: fit }));
	          var finalSrc = sizedSrc(transforms);
	
	          // construct blurry placeholder url
	          var thumbSize = { width: 20, height: 20, fit: 'crop' };
	          var thumbSrc = thumbBase(resizeImage(thumbSize))(['blur=amount:2']);
	
	          // construct srcSet if maxWidth provided
	          var srcSetImgs = srcSet(srcBase, getWidths(width, maxWidth), fit, transforms);
	          var sizes = imgSizes(maxWidth);
	
	          // The outer div is necessary to reset the z-index to 0.
	          return _react2['default'].createElement(
	            'div',
	            {
	              className: String(outerWrapperClassName) + ' graphcms-image-outer-wrapper',
	              style: {
	                zIndex: 0,
	                // Let users set component to be absolutely positioned.
	                position: style.position === 'absolute' ? 'initial' : 'relative'
	              }
	            },
	            _react2['default'].createElement(
	              'div',
	              {
	                className: String(className) + ' graphcms-image-wrapper',
	                style: Object.assign({
	                  position: 'relative',
	                  overflow: 'hidden',
	                  zIndex: 1
	                }, style),
	                ref: this.handleRef
	              },
	              _react2['default'].createElement('div', {
	                style: {
	                  width: '100%',
	                  paddingBottom: 100 / (width / height) + '%'
	                }
	              }),
	              blurryPlaceholder && _react2['default'].createElement(_Img2['default'], {
	                alt: alt,
	                title: title,
	                src: thumbSrc,
	                opacity: this.state.imgLoaded ? 0 : 1,
	                transitionDelay: '0.25s'
	              }),
	              backgroundColor && _react2['default'].createElement('div', {
	                title: title,
	                style: {
	                  backgroundColor: bgColor(backgroundColor),
	                  position: 'absolute',
	                  top: 0,
	                  bottom: 0,
	                  opacity: this.state.imgLoaded ? 0 : 1,
	                  transitionDelay: '0.25s',
	                  right: 0,
	                  left: 0
	                }
	              }),
	              this.state.isVisible && _react2['default'].createElement(_Img2['default'], {
	                alt: alt,
	                title: title,
	                srcSet: srcSetImgs,
	                src: finalSrc,
	                sizes: sizes,
	                opacity: this.state.imgLoaded || !fadeIn ? 1 : 0,
	                onLoad: this.onImageLoaded
	              })
	            )
	          );
	        }
	
	        return null;
	      }
	
	      return render;
	    }()
	  }]);
	
	  return GraphImage;
	}(_react2['default'].Component);
	
	GraphImage.defaultProps = {
	  title: '',
	  alt: '',
	  className: '',
	  outerWrapperClassName: '',
	  style: {},
	  fit: 'crop',
	  maxWidth: 800,
	  withWebp: true,
	  transforms: [],
	  blurryPlaceholder: true,
	  backgroundColor: '',
	  fadeIn: true,
	  onLoad: null,
	  baseURI: 'https://media.graphcms.com'
	};
	
	GraphImage.propTypes = {
	  title: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  // Support Glamor's css prop for classname
	  className: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  outerWrapperClassName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  style: _propTypes2['default'].object,
	  image: _propTypes2['default'].shape({
	    handle: _propTypes2['default'].string,
	    height: _propTypes2['default'].number,
	    width: _propTypes2['default'].number
	  }).isRequired,
	  fit: _propTypes2['default'].oneOf(['clip', 'crop', 'scale', 'max']),
	  maxWidth: _propTypes2['default'].number,
	  withWebp: _propTypes2['default'].bool,
	  transforms: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  onLoad: _propTypes2['default'].func,
	  blurryPlaceholder: _propTypes2['default'].bool,
	  backgroundColor: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  fadeIn: _propTypes2['default'].bool,
	  baseURI: _propTypes2['default'].string
	};
	
	exports['default'] = GraphImage;

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(196);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
	 *
	 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
	 *
	 */
	
	(function(window, document) {
	'use strict';
	
	
	// Exits early if all IntersectionObserver and IntersectionObserverEntry
	// features are natively supported.
	if ('IntersectionObserver' in window &&
	    'IntersectionObserverEntry' in window &&
	    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
	
	  // Minimal polyfill for Edge 15's lack of `isIntersecting`
	  // See: https://github.com/w3c/IntersectionObserver/issues/211
	  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
	    Object.defineProperty(window.IntersectionObserverEntry.prototype,
	      'isIntersecting', {
	      get: function () {
	        return this.intersectionRatio > 0;
	      }
	    });
	  }
	  return;
	}
	
	
	/**
	 * An IntersectionObserver registry. This registry exists to hold a strong
	 * reference to IntersectionObserver instances currently observering a target
	 * element. Without this registry, instances without another reference may be
	 * garbage collected.
	 */
	var registry = [];
	
	
	/**
	 * Creates the global IntersectionObserverEntry constructor.
	 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
	 * @param {Object} entry A dictionary of instance properties.
	 * @constructor
	 */
	function IntersectionObserverEntry(entry) {
	  this.time = entry.time;
	  this.target = entry.target;
	  this.rootBounds = entry.rootBounds;
	  this.boundingClientRect = entry.boundingClientRect;
	  this.intersectionRect = entry.intersectionRect || getEmptyRect();
	  this.isIntersecting = !!entry.intersectionRect;
	
	  // Calculates the intersection ratio.
	  var targetRect = this.boundingClientRect;
	  var targetArea = targetRect.width * targetRect.height;
	  var intersectionRect = this.intersectionRect;
	  var intersectionArea = intersectionRect.width * intersectionRect.height;
	
	  // Sets intersection ratio.
	  if (targetArea) {
	    this.intersectionRatio = intersectionArea / targetArea;
	  } else {
	    // If area is zero and is intersecting, sets to 1, otherwise to 0
	    this.intersectionRatio = this.isIntersecting ? 1 : 0;
	  }
	}
	
	
	/**
	 * Creates the global IntersectionObserver constructor.
	 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
	 * @param {Function} callback The function to be invoked after intersection
	 *     changes have queued. The function is not invoked if the queue has
	 *     been emptied by calling the `takeRecords` method.
	 * @param {Object=} opt_options Optional configuration options.
	 * @constructor
	 */
	function IntersectionObserver(callback, opt_options) {
	
	  var options = opt_options || {};
	
	  if (typeof callback != 'function') {
	    throw new Error('callback must be a function');
	  }
	
	  if (options.root && options.root.nodeType != 1) {
	    throw new Error('root must be an Element');
	  }
	
	  // Binds and throttles `this._checkForIntersections`.
	  this._checkForIntersections = throttle(
	      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
	
	  // Private properties.
	  this._callback = callback;
	  this._observationTargets = [];
	  this._queuedEntries = [];
	  this._rootMarginValues = this._parseRootMargin(options.rootMargin);
	
	  // Public properties.
	  this.thresholds = this._initThresholds(options.threshold);
	  this.root = options.root || null;
	  this.rootMargin = this._rootMarginValues.map(function(margin) {
	    return margin.value + margin.unit;
	  }).join(' ');
	}
	
	
	/**
	 * The minimum interval within which the document will be checked for
	 * intersection changes.
	 */
	IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
	
	
	/**
	 * The frequency in which the polyfill polls for intersection changes.
	 * this can be updated on a per instance basis and must be set prior to
	 * calling `observe` on the first target.
	 */
	IntersectionObserver.prototype.POLL_INTERVAL = null;
	
	/**
	 * Use a mutation observer on the root element
	 * to detect intersection changes.
	 */
	IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
	
	
	/**
	 * Starts observing a target element for intersection changes based on
	 * the thresholds values.
	 * @param {Element} target The DOM element to observe.
	 */
	IntersectionObserver.prototype.observe = function(target) {
	  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
	    return item.element == target;
	  });
	
	  if (isTargetAlreadyObserved) {
	    return;
	  }
	
	  if (!(target && target.nodeType == 1)) {
	    throw new Error('target must be an Element');
	  }
	
	  this._registerInstance();
	  this._observationTargets.push({element: target, entry: null});
	  this._monitorIntersections();
	  this._checkForIntersections();
	};
	
	
	/**
	 * Stops observing a target element for intersection changes.
	 * @param {Element} target The DOM element to observe.
	 */
	IntersectionObserver.prototype.unobserve = function(target) {
	  this._observationTargets =
	      this._observationTargets.filter(function(item) {
	
	    return item.element != target;
	  });
	  if (!this._observationTargets.length) {
	    this._unmonitorIntersections();
	    this._unregisterInstance();
	  }
	};
	
	
	/**
	 * Stops observing all target elements for intersection changes.
	 */
	IntersectionObserver.prototype.disconnect = function() {
	  this._observationTargets = [];
	  this._unmonitorIntersections();
	  this._unregisterInstance();
	};
	
	
	/**
	 * Returns any queue entries that have not yet been reported to the
	 * callback and clears the queue. This can be used in conjunction with the
	 * callback to obtain the absolute most up-to-date intersection information.
	 * @return {Array} The currently queued entries.
	 */
	IntersectionObserver.prototype.takeRecords = function() {
	  var records = this._queuedEntries.slice();
	  this._queuedEntries = [];
	  return records;
	};
	
	
	/**
	 * Accepts the threshold value from the user configuration object and
	 * returns a sorted array of unique threshold values. If a value is not
	 * between 0 and 1 and error is thrown.
	 * @private
	 * @param {Array|number=} opt_threshold An optional threshold value or
	 *     a list of threshold values, defaulting to [0].
	 * @return {Array} A sorted list of unique and valid threshold values.
	 */
	IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
	  var threshold = opt_threshold || [0];
	  if (!Array.isArray(threshold)) threshold = [threshold];
	
	  return threshold.sort().filter(function(t, i, a) {
	    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
	      throw new Error('threshold must be a number between 0 and 1 inclusively');
	    }
	    return t !== a[i - 1];
	  });
	};
	
	
	/**
	 * Accepts the rootMargin value from the user configuration object
	 * and returns an array of the four margin values as an object containing
	 * the value and unit properties. If any of the values are not properly
	 * formatted or use a unit other than px or %, and error is thrown.
	 * @private
	 * @param {string=} opt_rootMargin An optional rootMargin value,
	 *     defaulting to '0px'.
	 * @return {Array<Object>} An array of margin objects with the keys
	 *     value and unit.
	 */
	IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
	  var marginString = opt_rootMargin || '0px';
	  var margins = marginString.split(/\s+/).map(function(margin) {
	    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
	    if (!parts) {
	      throw new Error('rootMargin must be specified in pixels or percent');
	    }
	    return {value: parseFloat(parts[1]), unit: parts[2]};
	  });
	
	  // Handles shorthand.
	  margins[1] = margins[1] || margins[0];
	  margins[2] = margins[2] || margins[0];
	  margins[3] = margins[3] || margins[1];
	
	  return margins;
	};
	
	
	/**
	 * Starts polling for intersection changes if the polling is not already
	 * happening, and if the page's visibilty state is visible.
	 * @private
	 */
	IntersectionObserver.prototype._monitorIntersections = function() {
	  if (!this._monitoringIntersections) {
	    this._monitoringIntersections = true;
	
	    // If a poll interval is set, use polling instead of listening to
	    // resize and scroll events or DOM mutations.
	    if (this.POLL_INTERVAL) {
	      this._monitoringInterval = setInterval(
	          this._checkForIntersections, this.POLL_INTERVAL);
	    }
	    else {
	      addEvent(window, 'resize', this._checkForIntersections, true);
	      addEvent(document, 'scroll', this._checkForIntersections, true);
	
	      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
	        this._domObserver = new MutationObserver(this._checkForIntersections);
	        this._domObserver.observe(document, {
	          attributes: true,
	          childList: true,
	          characterData: true,
	          subtree: true
	        });
	      }
	    }
	  }
	};
	
	
	/**
	 * Stops polling for intersection changes.
	 * @private
	 */
	IntersectionObserver.prototype._unmonitorIntersections = function() {
	  if (this._monitoringIntersections) {
	    this._monitoringIntersections = false;
	
	    clearInterval(this._monitoringInterval);
	    this._monitoringInterval = null;
	
	    removeEvent(window, 'resize', this._checkForIntersections, true);
	    removeEvent(document, 'scroll', this._checkForIntersections, true);
	
	    if (this._domObserver) {
	      this._domObserver.disconnect();
	      this._domObserver = null;
	    }
	  }
	};
	
	
	/**
	 * Scans each observation target for intersection changes and adds them
	 * to the internal entries queue. If new entries are found, it
	 * schedules the callback to be invoked.
	 * @private
	 */
	IntersectionObserver.prototype._checkForIntersections = function() {
	  var rootIsInDom = this._rootIsInDom();
	  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
	
	  this._observationTargets.forEach(function(item) {
	    var target = item.element;
	    var targetRect = getBoundingClientRect(target);
	    var rootContainsTarget = this._rootContainsTarget(target);
	    var oldEntry = item.entry;
	    var intersectionRect = rootIsInDom && rootContainsTarget &&
	        this._computeTargetAndRootIntersection(target, rootRect);
	
	    var newEntry = item.entry = new IntersectionObserverEntry({
	      time: now(),
	      target: target,
	      boundingClientRect: targetRect,
	      rootBounds: rootRect,
	      intersectionRect: intersectionRect
	    });
	
	    if (!oldEntry) {
	      this._queuedEntries.push(newEntry);
	    } else if (rootIsInDom && rootContainsTarget) {
	      // If the new entry intersection ratio has crossed any of the
	      // thresholds, add a new entry.
	      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
	        this._queuedEntries.push(newEntry);
	      }
	    } else {
	      // If the root is not in the DOM or target is not contained within
	      // root but the previous entry for this target had an intersection,
	      // add a new record indicating removal.
	      if (oldEntry && oldEntry.isIntersecting) {
	        this._queuedEntries.push(newEntry);
	      }
	    }
	  }, this);
	
	  if (this._queuedEntries.length) {
	    this._callback(this.takeRecords(), this);
	  }
	};
	
	
	/**
	 * Accepts a target and root rect computes the intersection between then
	 * following the algorithm in the spec.
	 * TODO(philipwalton): at this time clip-path is not considered.
	 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
	 * @param {Element} target The target DOM element
	 * @param {Object} rootRect The bounding rect of the root after being
	 *     expanded by the rootMargin value.
	 * @return {?Object} The final intersection rect object or undefined if no
	 *     intersection is found.
	 * @private
	 */
	IntersectionObserver.prototype._computeTargetAndRootIntersection =
	    function(target, rootRect) {
	
	  // If the element isn't displayed, an intersection can't happen.
	  if (window.getComputedStyle(target).display == 'none') return;
	
	  var targetRect = getBoundingClientRect(target);
	  var intersectionRect = targetRect;
	  var parent = getParentNode(target);
	  var atRoot = false;
	
	  while (!atRoot) {
	    var parentRect = null;
	    var parentComputedStyle = parent.nodeType == 1 ?
	        window.getComputedStyle(parent) : {};
	
	    // If the parent isn't displayed, an intersection can't happen.
	    if (parentComputedStyle.display == 'none') return;
	
	    if (parent == this.root || parent == document) {
	      atRoot = true;
	      parentRect = rootRect;
	    } else {
	      // If the element has a non-visible overflow, and it's not the <body>
	      // or <html> element, update the intersection rect.
	      // Note: <body> and <html> cannot be clipped to a rect that's not also
	      // the document rect, so no need to compute a new intersection.
	      if (parent != document.body &&
	          parent != document.documentElement &&
	          parentComputedStyle.overflow != 'visible') {
	        parentRect = getBoundingClientRect(parent);
	      }
	    }
	
	    // If either of the above conditionals set a new parentRect,
	    // calculate new intersection data.
	    if (parentRect) {
	      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
	
	      if (!intersectionRect) break;
	    }
	    parent = getParentNode(parent);
	  }
	  return intersectionRect;
	};
	
	
	/**
	 * Returns the root rect after being expanded by the rootMargin value.
	 * @return {Object} The expanded root rect.
	 * @private
	 */
	IntersectionObserver.prototype._getRootRect = function() {
	  var rootRect;
	  if (this.root) {
	    rootRect = getBoundingClientRect(this.root);
	  } else {
	    // Use <html>/<body> instead of window since scroll bars affect size.
	    var html = document.documentElement;
	    var body = document.body;
	    rootRect = {
	      top: 0,
	      left: 0,
	      right: html.clientWidth || body.clientWidth,
	      width: html.clientWidth || body.clientWidth,
	      bottom: html.clientHeight || body.clientHeight,
	      height: html.clientHeight || body.clientHeight
	    };
	  }
	  return this._expandRectByRootMargin(rootRect);
	};
	
	
	/**
	 * Accepts a rect and expands it by the rootMargin value.
	 * @param {Object} rect The rect object to expand.
	 * @return {Object} The expanded rect.
	 * @private
	 */
	IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
	  var margins = this._rootMarginValues.map(function(margin, i) {
	    return margin.unit == 'px' ? margin.value :
	        margin.value * (i % 2 ? rect.width : rect.height) / 100;
	  });
	  var newRect = {
	    top: rect.top - margins[0],
	    right: rect.right + margins[1],
	    bottom: rect.bottom + margins[2],
	    left: rect.left - margins[3]
	  };
	  newRect.width = newRect.right - newRect.left;
	  newRect.height = newRect.bottom - newRect.top;
	
	  return newRect;
	};
	
	
	/**
	 * Accepts an old and new entry and returns true if at least one of the
	 * threshold values has been crossed.
	 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
	 *    particular target element or null if no previous entry exists.
	 * @param {IntersectionObserverEntry} newEntry The current entry for a
	 *    particular target element.
	 * @return {boolean} Returns true if a any threshold has been crossed.
	 * @private
	 */
	IntersectionObserver.prototype._hasCrossedThreshold =
	    function(oldEntry, newEntry) {
	
	  // To make comparing easier, an entry that has a ratio of 0
	  // but does not actually intersect is given a value of -1
	  var oldRatio = oldEntry && oldEntry.isIntersecting ?
	      oldEntry.intersectionRatio || 0 : -1;
	  var newRatio = newEntry.isIntersecting ?
	      newEntry.intersectionRatio || 0 : -1;
	
	  // Ignore unchanged ratios
	  if (oldRatio === newRatio) return;
	
	  for (var i = 0; i < this.thresholds.length; i++) {
	    var threshold = this.thresholds[i];
	
	    // Return true if an entry matches a threshold or if the new ratio
	    // and the old ratio are on the opposite sides of a threshold.
	    if (threshold == oldRatio || threshold == newRatio ||
	        threshold < oldRatio !== threshold < newRatio) {
	      return true;
	    }
	  }
	};
	
	
	/**
	 * Returns whether or not the root element is an element and is in the DOM.
	 * @return {boolean} True if the root element is an element and is in the DOM.
	 * @private
	 */
	IntersectionObserver.prototype._rootIsInDom = function() {
	  return !this.root || containsDeep(document, this.root);
	};
	
	
	/**
	 * Returns whether or not the target element is a child of root.
	 * @param {Element} target The target element to check.
	 * @return {boolean} True if the target element is a child of root.
	 * @private
	 */
	IntersectionObserver.prototype._rootContainsTarget = function(target) {
	  return containsDeep(this.root || document, target);
	};
	
	
	/**
	 * Adds the instance to the global IntersectionObserver registry if it isn't
	 * already present.
	 * @private
	 */
	IntersectionObserver.prototype._registerInstance = function() {
	  if (registry.indexOf(this) < 0) {
	    registry.push(this);
	  }
	};
	
	
	/**
	 * Removes the instance from the global IntersectionObserver registry.
	 * @private
	 */
	IntersectionObserver.prototype._unregisterInstance = function() {
	  var index = registry.indexOf(this);
	  if (index != -1) registry.splice(index, 1);
	};
	
	
	/**
	 * Returns the result of the performance.now() method or null in browsers
	 * that don't support the API.
	 * @return {number} The elapsed time since the page was requested.
	 */
	function now() {
	  return window.performance && performance.now && performance.now();
	}
	
	
	/**
	 * Throttles a function and delays its executiong, so it's only called at most
	 * once within a given time period.
	 * @param {Function} fn The function to throttle.
	 * @param {number} timeout The amount of time that must pass before the
	 *     function can be called again.
	 * @return {Function} The throttled function.
	 */
	function throttle(fn, timeout) {
	  var timer = null;
	  return function () {
	    if (!timer) {
	      timer = setTimeout(function() {
	        fn();
	        timer = null;
	      }, timeout);
	    }
	  };
	}
	
	
	/**
	 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
	 * @param {Node} node The DOM node to add the event handler to.
	 * @param {string} event The event name.
	 * @param {Function} fn The event handler to add.
	 * @param {boolean} opt_useCapture Optionally adds the even to the capture
	 *     phase. Note: this only works in modern browsers.
	 */
	function addEvent(node, event, fn, opt_useCapture) {
	  if (typeof node.addEventListener == 'function') {
	    node.addEventListener(event, fn, opt_useCapture || false);
	  }
	  else if (typeof node.attachEvent == 'function') {
	    node.attachEvent('on' + event, fn);
	  }
	}
	
	
	/**
	 * Removes a previously added event handler from a DOM node.
	 * @param {Node} node The DOM node to remove the event handler from.
	 * @param {string} event The event name.
	 * @param {Function} fn The event handler to remove.
	 * @param {boolean} opt_useCapture If the event handler was added with this
	 *     flag set to true, it should be set to true here in order to remove it.
	 */
	function removeEvent(node, event, fn, opt_useCapture) {
	  if (typeof node.removeEventListener == 'function') {
	    node.removeEventListener(event, fn, opt_useCapture || false);
	  }
	  else if (typeof node.detatchEvent == 'function') {
	    node.detatchEvent('on' + event, fn);
	  }
	}
	
	
	/**
	 * Returns the intersection between two rect objects.
	 * @param {Object} rect1 The first rect.
	 * @param {Object} rect2 The second rect.
	 * @return {?Object} The intersection rect or undefined if no intersection
	 *     is found.
	 */
	function computeRectIntersection(rect1, rect2) {
	  var top = Math.max(rect1.top, rect2.top);
	  var bottom = Math.min(rect1.bottom, rect2.bottom);
	  var left = Math.max(rect1.left, rect2.left);
	  var right = Math.min(rect1.right, rect2.right);
	  var width = right - left;
	  var height = bottom - top;
	
	  return (width >= 0 && height >= 0) && {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right,
	    width: width,
	    height: height
	  };
	}
	
	
	/**
	 * Shims the native getBoundingClientRect for compatibility with older IE.
	 * @param {Element} el The element whose bounding rect to get.
	 * @return {Object} The (possibly shimmed) rect of the element.
	 */
	function getBoundingClientRect(el) {
	  var rect;
	
	  try {
	    rect = el.getBoundingClientRect();
	  } catch (err) {
	    // Ignore Windows 7 IE11 "Unspecified error"
	    // https://github.com/w3c/IntersectionObserver/pull/205
	  }
	
	  if (!rect) return getEmptyRect();
	
	  // Older IE
	  if (!(rect.width && rect.height)) {
	    rect = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.right - rect.left,
	      height: rect.bottom - rect.top
	    };
	  }
	  return rect;
	}
	
	
	/**
	 * Returns an empty rect object. An empty rect is returned when an element
	 * is not in the DOM.
	 * @return {Object} The empty rect.
	 */
	function getEmptyRect() {
	  return {
	    top: 0,
	    bottom: 0,
	    left: 0,
	    right: 0,
	    width: 0,
	    height: 0
	  };
	}
	
	/**
	 * Checks to see if a parent element contains a child elemnt (including inside
	 * shadow DOM).
	 * @param {Node} parent The parent element.
	 * @param {Node} child The child element.
	 * @return {boolean} True if the parent node contains the child node.
	 */
	function containsDeep(parent, child) {
	  var node = child;
	  while (node) {
	    if (node == parent) return true;
	
	    node = getParentNode(node);
	  }
	  return false;
	}
	
	
	/**
	 * Gets the parent node of an element or its host element if the parent node
	 * is a shadow root.
	 * @param {Node} node The node whose parent to get.
	 * @return {Node|null} The parent node or null if no parent exists.
	 */
	function getParentNode(node) {
	  var parent = node.parentNode;
	
	  if (parent && parent.nodeType == 11 && parent.host) {
	    // If the parent is a shadow root, return the host element.
	    return parent.host;
	  }
	  return parent;
	}
	
	
	// Exposes the constructors globally.
	window.IntersectionObserver = IntersectionObserver;
	window.IntersectionObserverEntry = IntersectionObserverEntry;
	
	}(window, document));


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class /;
	var isES6ClassFn = function isES6ClassFn(value) {
		try {
			var fnStr = fnToStr.call(value);
			var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
			var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
			var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
			return constructorRegex.test(spaceStripped);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionObject(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),

/***/ 453:
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(158);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') { return false; }
			return symStringRegex.test(symToStr.call(value));
		};
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') { return true; }
			if (toStr.call(value) !== '[object Symbol]') { return false; }
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false;
		};
	}


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(399);
	var has = __webpack_require__(158);
	var bind = __webpack_require__(196);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function values(O) {
		var obj = ES.RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				vals.push(obj[key]);
			}
		}
		return vals;
	};


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(244);
	
	var implementation = __webpack_require__(259);
	var getPolyfill = __webpack_require__(260);
	var shim = __webpack_require__(490);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(259);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(260);
	var define = __webpack_require__(244);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = HamburgerMenu;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HamburgerMenu(props) {
	  var width = (props.width || 36) + "px",
	      height = (props.height || 30) + "px",
	      halfHeight = parseInt(height.replace('px', '')) / 2 + "px",
	      isOpen = props.isOpen || false,
	      strokeWidth = props.strokeWidth || 2,
	      halfStrokeWidth = "-" + strokeWidth / 2 + "px",
	      animationDuration = props.animationDuration || '0.4';
	
	  var getTransformValue = function getTransformValue(isOpen, defaultPos, rotateVal) {
	    return "translate3d(0," + (isOpen ? halfHeight : defaultPos) + ",0) rotate(" + (isOpen ? rotateVal + "deg" : '0') + ")";
	  };
	
	  var styles = {
	    container: {
	      width: width,
	      height: height,
	      position: 'relative',
	      transform: "rotate(" + (props.rotate || 0) + "deg)"
	    },
	    lineBase: {
	      display: 'block',
	      height: strokeWidth + "px",
	      width: '100%',
	      background: props.color || '#000',
	      transitionTimingFunction: 'ease',
	      transitionDuration: animationDuration + "s",
	      borderRadius: (props.borderRadius || 0) + "px",
	      transformOrigin: 'center',
	      position: 'absolute'
	    },
	    firstLine: {
	      transform: getTransformValue(isOpen, 0, 45),
	      marginTop: halfStrokeWidth
	    },
	    secondLine: {
	      transitionTimingFunction: 'ease-out',
	      transitionDuration: animationDuration / 4 + "s",
	      opacity: isOpen ? '0' : '1',
	      top: halfHeight,
	      marginTop: halfStrokeWidth
	    },
	    thirdLine: {
	      transform: getTransformValue(isOpen, height, -45),
	      marginTop: halfStrokeWidth
	    }
	  };
	  return _react.default.createElement("div", {
	    style: styles.container,
	    onClick: props.menuClicked
	  }, _react.default.createElement("span", {
	    style: Object.assign({}, styles.lineBase, styles.firstLine)
	  }), _react.default.createElement("span", {
	    style: Object.assign({}, styles.lineBase, styles.secondLine)
	  }), _react.default.createElement("span", {
	    style: Object.assign({}, styles.lineBase, styles.thirdLine)
	  }));
	}
	
	;
	HamburgerMenu.propTypes = {
	  isOpen: _propTypes.default.bool.isRequired,
	  menuClicked: _propTypes.default.func.isRequired,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  strokeWidth: _propTypes.default.number,
	  rotate: _propTypes.default.number,
	  color: _propTypes.default.string,
	  borderRadius: _propTypes.default.number,
	  animationDuration: _propTypes.default.number
	};

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(524);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(385);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(497);
	
	var _HelmetConstants = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(205);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(269);
	
	var _consolidatedEvents = __webpack_require__(312);
	
	var _object = __webpack_require__(489);
	
	var _object2 = _interopRequireDefault(_object);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISPLAY = {
	  BLOCK: 'block',
	  FLEX: 'flex',
	  INLINE_BLOCK: 'inline-block'
	};
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes2['default'].node.isRequired,
	  onOutsideClick: _propTypes2['default'].func.isRequired,
	  disabled: _propTypes2['default'].bool,
	  useCapture: _propTypes2['default'].bool,
	  display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
	});
	
	var defaultProps = {
	  disabled: false,
	
	  // `useCapture` is set to true by default so that a `stopPropagation` in the
	  // children will not prevent all outside click handlers from firing - maja
	  useCapture: true,
	  display: DISPLAY.BLOCK
	};
	
	var OutsideClickHandler = function (_React$Component) {
	  _inherits(OutsideClickHandler, _React$Component);
	
	  function OutsideClickHandler() {
	    var _ref;
	
	    _classCallCheck(this, OutsideClickHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));
	
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(OutsideClickHandler, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _props = this.props,
	            disabled = _props.disabled,
	            useCapture = _props.useCapture;
	
	
	        if (!disabled) this.addMouseDownEventListener(useCapture);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(_ref2) {
	        var disabled = _ref2.disabled,
	            useCapture = _ref2.useCapture;
	        var prevDisabled = this.props.disabled;
	
	        if (prevDisabled !== disabled) {
	          if (disabled) {
	            this.removeEventListeners();
	          } else {
	            this.addMouseDownEventListener(useCapture);
	          }
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        this.removeEventListeners();
	      }
	
	      return componentWillUnmount;
	    }()
	
	    // Use mousedown/mouseup to enforce that clicks remain outside the root's
	    // descendant tree, even when dragged. This should also get triggered on
	    // touch devices.
	
	  }, {
	    key: 'onMouseDown',
	    value: function () {
	      function onMouseDown(e) {
	        var useCapture = this.props.useCapture;
	
	
	        var isDescendantOfRoot = this.childNode && this.childNode.contains(e.target);
	        if (!isDescendantOfRoot) {
	          this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, 'mouseup', this.onMouseUp, { capture: useCapture });
	        }
	      }
	
	      return onMouseDown;
	    }()
	
	    // Use mousedown/mouseup to enforce that clicks remain outside the root's
	    // descendant tree, even when dragged. This should also get triggered on
	    // touch devices.
	
	  }, {
	    key: 'onMouseUp',
	    value: function () {
	      function onMouseUp(e) {
	        var onOutsideClick = this.props.onOutsideClick;
	
	
	        var isDescendantOfRoot = this.childNode && this.childNode.contains(e.target);
	        if (this.removeMouseUp) this.removeMouseUp();
	        this.removeMouseUp = null;
	
	        if (!isDescendantOfRoot) {
	          onOutsideClick(e);
	        }
	      }
	
	      return onMouseUp;
	    }()
	  }, {
	    key: 'setChildNodeRef',
	    value: function () {
	      function setChildNodeRef(ref) {
	        this.childNode = ref;
	      }
	
	      return setChildNodeRef;
	    }()
	  }, {
	    key: 'addMouseDownEventListener',
	    value: function () {
	      function addMouseDownEventListener(useCapture) {
	        this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, 'mousedown', this.onMouseDown, { capture: useCapture });
	      }
	
	      return addMouseDownEventListener;
	    }()
	  }, {
	    key: 'removeEventListeners',
	    value: function () {
	      function removeEventListeners() {
	        if (this.removeMouseDown) this.removeMouseDown();
	        if (this.removeMouseUp) this.removeMouseUp();
	      }
	
	      return removeEventListeners;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props2 = this.props,
	            children = _props2.children,
	            display = _props2.display;
	
	
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: this.setChildNodeRef,
	            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? { display: display } : undefined
	          },
	          children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return OutsideClickHandler;
	}(_react2['default'].Component);
	
	exports['default'] = OutsideClickHandler;
	
	
	OutsideClickHandler.propTypes = propTypes;
	OutsideClickHandler.defaultProps = defaultProps;

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(512);


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	!function(root, factory) {
	     true ? module.exports = factory(__webpack_require__(1)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.react);
	}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
	    return function(modules) {
	        function __webpack_require__(moduleId) {
	            if (installedModules[moduleId]) return installedModules[moduleId].exports;
	            var module = installedModules[moduleId] = {
	                i: moduleId,
	                l: !1,
	                exports: {}
	            };
	            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
	            module.l = !0, module.exports;
	        }
	        var installedModules = {};
	        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
	        __webpack_require__.d = function(exports, name, getter) {
	            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
	                configurable: !1,
	                enumerable: !0,
	                get: getter
	            });
	        }, __webpack_require__.n = function(module) {
	            var getter = module && module.__esModule ? function() {
	                return module.default;
	            } : function() {
	                return module;
	            };
	            return __webpack_require__.d(getter, "a", getter), getter;
	        }, __webpack_require__.o = function(object, property) {
	            return Object.prototype.hasOwnProperty.call(object, property);
	        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 4);
	    }([ function(module, exports, __webpack_require__) {
	        var REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, isValidElement = function(object) {
	            return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
	        };
	        module.exports = __webpack_require__(6)(isValidElement, !0);
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function hyphenateStyleName(string) {
	            return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
	        }
	        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
	        module.exports = hyphenateStyleName;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        });
	        var _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _propTypes = __webpack_require__(0), _propTypes2 = function(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }(_propTypes), stringOrNumber = _propTypes2.default.oneOfType([ _propTypes2.default.string, _propTypes2.default.number ]), matchers = {
	            orientation: _propTypes2.default.oneOf([ "portrait", "landscape" ]),
	            scan: _propTypes2.default.oneOf([ "progressive", "interlace" ]),
	            aspectRatio: _propTypes2.default.string,
	            deviceAspectRatio: _propTypes2.default.string,
	            height: stringOrNumber,
	            deviceHeight: stringOrNumber,
	            width: stringOrNumber,
	            deviceWidth: stringOrNumber,
	            color: _propTypes2.default.bool,
	            colorIndex: _propTypes2.default.bool,
	            monochrome: _propTypes2.default.bool,
	            resolution: stringOrNumber
	        }, features = _extends({
	            minAspectRatio: _propTypes2.default.string,
	            maxAspectRatio: _propTypes2.default.string,
	            minDeviceAspectRatio: _propTypes2.default.string,
	            maxDeviceAspectRatio: _propTypes2.default.string,
	            minHeight: stringOrNumber,
	            maxHeight: stringOrNumber,
	            minDeviceHeight: stringOrNumber,
	            maxDeviceHeight: stringOrNumber,
	            minWidth: stringOrNumber,
	            maxWidth: stringOrNumber,
	            minDeviceWidth: stringOrNumber,
	            maxDeviceWidth: stringOrNumber,
	            minColor: _propTypes2.default.number,
	            maxColor: _propTypes2.default.number,
	            minColorIndex: _propTypes2.default.number,
	            maxColorIndex: _propTypes2.default.number,
	            minMonochrome: _propTypes2.default.number,
	            maxMonochrome: _propTypes2.default.number,
	            minResolution: stringOrNumber,
	            maxResolution: stringOrNumber
	        }, matchers), types = {
	            all: _propTypes2.default.bool,
	            grid: _propTypes2.default.bool,
	            aural: _propTypes2.default.bool,
	            braille: _propTypes2.default.bool,
	            handheld: _propTypes2.default.bool,
	            print: _propTypes2.default.bool,
	            projection: _propTypes2.default.bool,
	            screen: _propTypes2.default.bool,
	            tty: _propTypes2.default.bool,
	            tv: _propTypes2.default.bool,
	            embossed: _propTypes2.default.bool
	        }, all = _extends({}, types, features);
	        matchers.type = Object.keys(types), exports.default = {
	            all: all,
	            types: types,
	            matchers: matchers,
	            features: features
	        }, module.exports = exports.default;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function _classCallCheck(instance, Constructor) {
	            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
	        }
	        function _possibleConstructorReturn(self, call) {
	            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	            return !call || "object" != typeof call && "function" != typeof call ? self : call;
	        }
	        function _inherits(subClass, superClass) {
	            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	            subClass.prototype = Object.create(superClass && superClass.prototype, {
	                constructor: {
	                    value: subClass,
	                    enumerable: !1,
	                    writable: !0,
	                    configurable: !0
	                }
	            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	        }
	        function omit(object, keys) {
	            var newObject = _extends({}, object);
	            return keys.forEach(function(key) {
	                return delete newObject[key];
	            }), newObject;
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.toQuery = exports.default = void 0;
	        var _createClass = function() {
	            function defineProperties(target, props) {
	                for (var i = 0; i < props.length; i++) {
	                    var descriptor = props[i];
	                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
	                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	                }
	            }
	            return function(Constructor, protoProps, staticProps) {
	                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
	                Constructor;
	            };
	        }(), _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _react = __webpack_require__(5), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(0), _propTypes2 = _interopRequireDefault(_propTypes), _matchmediaquery = __webpack_require__(9), _matchmediaquery2 = _interopRequireDefault(_matchmediaquery), _hyphenateStyleName = __webpack_require__(2), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(3), _mediaQuery2 = _interopRequireDefault(_mediaQuery), _toQuery = __webpack_require__(11), _toQuery2 = _interopRequireDefault(_toQuery), defaultTypes = {
	            component: _propTypes2.default.node,
	            query: _propTypes2.default.string,
	            values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
	            children: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.func ]),
	            onChange: _propTypes2.default.func,
	            onBeforeChange: _propTypes2.default.func
	        }, mediaKeys = Object.keys(_mediaQuery2.default.all), excludedQueryKeys = Object.keys(defaultTypes), excludedPropKeys = excludedQueryKeys.concat(mediaKeys), MediaQuery = function(_React$Component) {
	            function MediaQuery() {
	                var _ref, _temp, _this, _ret;
	                _classCallCheck(this, MediaQuery);
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
	                return _temp = _this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [ this ].concat(args))), 
	                _this.state = {
	                    matches: !1
	                }, _this.updateMatches = function() {
	                    _this._mql.matches !== _this.state.matches && _this.setState({
	                        matches: _this._mql.matches
	                    });
	                }, _this.removeMql = function() {
	                    _this._mql && (_this._mql.removeListener(_this.updateMatches), _this._mql.dispose());
	                }, _ret = _temp, _possibleConstructorReturn(_this, _ret);
	            }
	            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, [ {
	                key: "componentWillMount",
	                value: function() {
	                    this.updateQuery(this.props);
	                }
	            }, {
	                key: "componentWillReceiveProps",
	                value: function(nextProps) {
	                    this.updateQuery(nextProps);
	                }
	            }, {
	                key: "updateQuery",
	                value: function(props) {
	                    var values = void 0, forceStatic = !1;
	                    if (props.query ? this.query = props.query : this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys)), 
	                    !this.query) throw new Error("Invalid or missing MediaQuery!");
	                    props.values && (values = Object.keys(props.values).reduce(function(result, key) {
	                        return result[(0, _hyphenateStyleName2.default)(key)] = props.values[key], result;
	                    }, {}), 0 !== Object.keys(values).length && (forceStatic = !0)), this.removeMql(), 
	                    this._mql = (0, _matchmediaquery2.default)(this.query, values, forceStatic), this._mql.addListener(this.updateMatches), 
	                    this.updateMatches();
	                }
	            }, {
	                key: "componentWillUpdate",
	                value: function(_, nextState) {
	                    this.props.onBeforeChange && this.state.matches !== nextState.matches && this.props.onBeforeChange(this.state.matches);
	                }
	            }, {
	                key: "componentDidUpdate",
	                value: function(_, prevState) {
	                    this.props.onChange && prevState.matches !== this.state.matches && this.props.onChange(this.state.matches);
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function() {
	                    this.removeMql();
	                }
	            }, {
	                key: "render",
	                value: function() {
	                    if ("function" == typeof this.props.children) return this.props.children(this.state.matches);
	                    if (!1 === this.state.matches) return null;
	                    var props = omit(this.props, excludedPropKeys), hasMergeProps = Object.keys(props).length > 0, childrenCount = _react2.default.Children.count(this.props.children);
	                    return this.props.component || null == this.props.children || hasMergeProps && childrenCount > 1 ? _react2.default.createElement(this.props.component || "div", props, this.props.children) : hasMergeProps ? _react2.default.cloneElement(this.props.children, props) : childrenCount ? this.props.children : null;
	                }
	            } ]), MediaQuery;
	        }(_react2.default.Component);
	        MediaQuery.displayName = "MediaQuery", MediaQuery.defaultProps = {
	            values: {}
	        }, exports.default = MediaQuery, exports.toQuery = _toQuery2.default;
	    }, function(module, exports) {
	        module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function emptyFunctionThatReturnsNull() {
	            return null;
	        }
	        var assign = __webpack_require__(7), ReactPropTypesSecret = __webpack_require__(1), checkPropTypes = __webpack_require__(8), printWarning = function() {};
	        printWarning = function(text) {
	            var message = "Warning: " + text;
	            "undefined" != typeof console && console.error(message);
	            try {
	                throw new Error(message);
	            } catch (x) {}
	        }, module.exports = function(isValidElement, throwOnDirectAccess) {
	            function getIteratorFn(maybeIterable) {
	                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	                if ("function" == typeof iteratorFn) return iteratorFn;
	            }
	            function is(x, y) {
	                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
	            }
	            function PropTypeError(message) {
	                this.message = message, this.stack = "";
	            }
	            function createChainableTypeChecker(validate) {
	                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
	                    secret !== ReactPropTypesSecret) {
	                        if (throwOnDirectAccess) {
	                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
	                            throw err.name = "Invariant Violation", err;
	                        }
	                        if ("undefined" != typeof console) {
	                            var cacheKey = componentName + ":" + propName;
	                            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), 
	                            manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
	                        }
	                    }
	                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
	                }
	                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
	                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
	            }
	            function createPrimitiveTypeChecker(expectedType) {
	                function validate(props, propName, componentName, location, propFullName, secret) {
	                    var propValue = props[propName];
	                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createArrayOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
	                    var propValue = props[propName];
	                    if (!Array.isArray(propValue)) {
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
	                    }
	                    for (var i = 0; i < propValue.length; i++) {
	                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createInstanceTypeChecker(expectedClass) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if (!(props[propName] instanceof expectedClass)) {
	                        var expectedClassName = expectedClass.name || ANONYMOUS;
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createEnumTypeChecker(expectedValues) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` supplied to `" + componentName + "`, expected one of " + JSON.stringify(expectedValues) + ".");
	                }
	                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning("Invalid argument supplied to oneOf, expected an instance of array."), 
	                emptyFunctionThatReturnsNull);
	            }
	            function createObjectOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
	                    for (var key in propValue) if (propValue.hasOwnProperty(key)) {
	                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createUnionTypeChecker(arrayOfTypeCheckers) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
	                    }
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
	                }
	                if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), 
	                emptyFunctionThatReturnsNull;
	                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                    var checker = arrayOfTypeCheckers[i];
	                    if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), 
	                    emptyFunctionThatReturnsNull;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    for (var key in shapeTypes) {
	                        var checker = shapeTypes[key];
	                        if (checker) {
	                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                            if (error) return error;
	                        }
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createStrictShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    var allKeys = assign({}, props[propName], shapeTypes);
	                    for (var key in allKeys) {
	                        var checker = shapeTypes[key];
	                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
	                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function isNode(propValue) {
	                switch (typeof propValue) {
	                  case "number":
	                  case "string":
	                  case "undefined":
	                    return !0;
	
	                  case "boolean":
	                    return !propValue;
	
	                  case "object":
	                    if (Array.isArray(propValue)) return propValue.every(isNode);
	                    if (null === propValue || isValidElement(propValue)) return !0;
	                    var iteratorFn = getIteratorFn(propValue);
	                    if (!iteratorFn) return !1;
	                    var step, iterator = iteratorFn.call(propValue);
	                    if (iteratorFn !== propValue.entries) {
	                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
	                    } else for (;!(step = iterator.next()).done; ) {
	                        var entry = step.value;
	                        if (entry && !isNode(entry[1])) return !1;
	                    }
	                    return !0;
	
	                  default:
	                    return !1;
	                }
	            }
	            function isSymbol(propType, propValue) {
	                return "symbol" === propType || ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
	            }
	            function getPropType(propValue) {
	                var propType = typeof propValue;
	                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
	            }
	            function getPreciseType(propValue) {
	                if (void 0 === propValue || null === propValue) return "" + propValue;
	                var propType = getPropType(propValue);
	                if ("object" === propType) {
	                    if (propValue instanceof Date) return "date";
	                    if (propValue instanceof RegExp) return "regexp";
	                }
	                return propType;
	            }
	            function getPostfixForTypeWarning(value) {
	                var type = getPreciseType(value);
	                switch (type) {
	                  case "array":
	                  case "object":
	                    return "an " + type;
	
	                  case "boolean":
	                  case "date":
	                  case "regexp":
	                    return "a " + type;
	
	                  default:
	                    return type;
	                }
	            }
	            function getClassName(propValue) {
	                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
	            }
	            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
	                array: createPrimitiveTypeChecker("array"),
	                bool: createPrimitiveTypeChecker("boolean"),
	                func: createPrimitiveTypeChecker("function"),
	                number: createPrimitiveTypeChecker("number"),
	                object: createPrimitiveTypeChecker("object"),
	                string: createPrimitiveTypeChecker("string"),
	                symbol: createPrimitiveTypeChecker("symbol"),
	                any: function() {
	                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	                }(),
	                arrayOf: createArrayOfTypeChecker,
	                element: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        var propValue = props[propName];
	                        if (!isValidElement(propValue)) {
	                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
	                        }
	                        return null;
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                instanceOf: createInstanceTypeChecker,
	                node: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                objectOf: createObjectOfTypeChecker,
	                oneOf: createEnumTypeChecker,
	                oneOfType: createUnionTypeChecker,
	                shape: createShapeTypeChecker,
	                exact: createStrictShapeTypeChecker
	            };
	            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
	            ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function toObject(val) {
	            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
	            return Object(val);
	        }
	        /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
	        module.exports = function() {
	            try {
	                if (!Object.assign) return !1;
	                var test1 = new String("abc");
	                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
	                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
	                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
	                    return test2[n];
	                }).join("")) return !1;
	                var test3 = {};
	                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
	                    test3[letter] = letter;
	                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
	            } catch (err) {
	                return !1;
	            }
	        }() ? Object.assign : function(target, source) {
	            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
	                from = Object(arguments[s]);
	                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
	                if (getOwnPropertySymbols) {
	                    symbols = getOwnPropertySymbols(from);
	                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
	                }
	            }
	            return to;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	            for (var typeSpecName in typeSpecs) if (typeSpecs.hasOwnProperty(typeSpecName)) {
	                var error;
	                try {
	                    if ("function" != typeof typeSpecs[typeSpecName]) {
	                        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
	                        throw err.name = "Invariant Violation", err;
	                    }
	                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	                } catch (ex) {
	                    error = ex;
	                }
	                if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), 
	                error instanceof Error && !(error.message in loggedTypeFailures)) {
	                    loggedTypeFailures[error.message] = !0;
	                    var stack = getStack ? getStack() : "";
	                    printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
	                }
	            }
	        }
	        var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(1), loggedTypeFailures = {};
	        printWarning = function(text) {
	            var message = "Warning: " + text;
	            "undefined" != typeof console && console.error(message);
	            try {
	                throw new Error(message);
	            } catch (x) {}
	        }, module.exports = checkPropTypes;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function Mql(query, values, forceStatic) {
	            function addListener(listener) {
	                mql && mql.addListener(listener);
	            }
	            function removeListener(listener) {
	                mql && mql.removeListener(listener);
	            }
	            function update(evt) {
	                self.matches = evt.matches, self.media = evt.media;
	            }
	            function dispose() {
	                mql && mql.removeListener(update);
	            }
	            var self = this;
	            if (dynamicMatch && !forceStatic) {
	                var mql = dynamicMatch.call(window, query);
	                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
	            } else this.matches = staticMatch(query, values), this.media = query;
	            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
	        }
	        function matchMedia(query, values, forceStatic) {
	            return new Mql(query, values, forceStatic);
	        }
	        var staticMatch = __webpack_require__(10).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
	        module.exports = matchMedia;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function matchQuery(mediaQuery, values) {
	            return parseQuery(mediaQuery).some(function(query) {
	                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
	                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
	                var expressionsMatch = query.expressions.every(function(expression) {
	                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
	                    if (!value) return !1;
	                    switch (feature) {
	                      case "orientation":
	                      case "scan":
	                        return value.toLowerCase() === expValue.toLowerCase();
	
	                      case "width":
	                      case "height":
	                      case "device-width":
	                      case "device-height":
	                        expValue = toPx(expValue), value = toPx(value);
	                        break;
	
	                      case "resolution":
	                        expValue = toDpi(expValue), value = toDpi(value);
	                        break;
	
	                      case "aspect-ratio":
	                      case "device-aspect-ratio":
	                      case "device-pixel-ratio":
	                        expValue = toDecimal(expValue), value = toDecimal(value);
	                        break;
	
	                      case "grid":
	                      case "color":
	                      case "color-index":
	                      case "monochrome":
	                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
	                    }
	                    switch (modifier) {
	                      case "min":
	                        return value >= expValue;
	
	                      case "max":
	                        return value <= expValue;
	
	                      default:
	                        return value === expValue;
	                    }
	                });
	                return expressionsMatch && !inverse || !expressionsMatch && inverse;
	            });
	        }
	        function parseQuery(mediaQuery) {
	            return mediaQuery.split(",").map(function(query) {
	                query = query.trim();
	                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
	                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
	                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
	                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	                    return {
	                        modifier: feature[1],
	                        feature: feature[2],
	                        value: captures[2]
	                    };
	                }), parsed;
	            });
	        }
	        function toDecimal(ratio) {
	            var numbers, decimal = Number(ratio);
	            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
	            decimal;
	        }
	        function toDpi(resolution) {
	            var value = parseFloat(resolution);
	            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
	              case "dpcm":
	                return value / 2.54;
	
	              case "dppx":
	                return 96 * value;
	
	              default:
	                return value;
	            }
	        }
	        function toPx(length) {
	            var value = parseFloat(length);
	            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
	              case "em":
	              case "rem":
	                return 16 * value;
	
	              case "cm":
	                return 96 * value / 2.54;
	
	              case "mm":
	                return 96 * value / 2.54 / 10;
	
	              case "in":
	                return 96 * value;
	
	              case "pt":
	                return 72 * value;
	
	              case "pc":
	                return 72 * value / 12;
	
	              default:
	                return value;
	            }
	        }
	        exports.match = matchQuery, exports.parse = parseQuery;
	        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function keyVal(k, v) {
	            var realKey = (0, _hyphenateStyleName2.default)(k);
	            return "number" == typeof v && (v += "px"), !0 === v ? k : !1 === v ? negate(k) : "(" + realKey + ": " + v + ")";
	        }
	        function join(conds) {
	            return conds.join(" and ");
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.default = function(obj) {
	            var rules = [];
	            return Object.keys(_mediaQuery2.default.all).forEach(function(k) {
	                var v = obj[k];
	                null != v && rules.push(keyVal(k, v));
	            }), join(rules);
	        };
	        var _hyphenateStyleName = __webpack_require__(2), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(3), _mediaQuery2 = _interopRequireDefault(_mediaQuery), negate = function(cond) {
	            return "not " + cond;
	        };
	        module.exports = exports.default;
	    } ]);
	});
	//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(49);
	
	var _utils = __webpack_require__(214);
	
	var _withTouchListeners = __webpack_require__(523);
	
	var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
	
	var _StyleSheet = __webpack_require__(521);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollLock = function (_PureComponent) {
	  _inherits(ScrollLock, _PureComponent);
	
	  function ScrollLock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
	      var accountForScrollbars = _this.props.accountForScrollbars;
	
	
	      var height = (0, _utils.getDocumentHeight)();
	      var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
	      var styles = 'body {\n      box-sizing: border-box !important;\n      overflow: hidden !important;\n      position: relative !important;\n      ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n      ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n    }';
	
	      return styles;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScrollLock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_exenv.canUseDOM) return;
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var offset = window.innerHeight - this.initialHeight;
	
	      // adjust scroll if the window has been resized since the lock was engaged
	      // e.g. mobile safari dynamic chrome heights
	      if (offset) {
	        window.scrollTo(0, window.pageYOffset + offset);
	      }
	
	      // reset the initial height in case this scroll lock is used again
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_StyleSheet2.default, { styles: this.getStyles() });
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.PureComponent);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(49);
	
	var _utils = __webpack_require__(214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sheet = function (_PureComponent) {
	  _inherits(Sheet, _PureComponent);
	
	  function Sheet() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sheet);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call.apply(_ref, [this].concat(args))), _this), _this.addSheet = function () {
	      var styles = _this.props.styles;
	
	
	      var sheet = (0, _utils.makeStyleTag)();
	      if (!sheet) return;
	
	      (0, _utils.injectStyles)(sheet, styles);
	      (0, _utils.insertStyleTag)(sheet);
	
	      _this.sheet = sheet;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sheet, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_exenv.canUseDOM) return;
	      this.addSheet();
	    }
	  }, {
	    key: 'removeSheet',
	    value: function removeSheet() {
	      if (!this.sheet) return;
	
	      // $FlowFixMe
	      this.sheet.parentNode.removeChild(this.sheet);
	      this.sheet = null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeSheet();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Sheet;
	}(_react.PureComponent);
	
	exports.default = Sheet;

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollLock = __webpack_require__(520);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollLock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	exports.getPadding = getPadding;
	exports.camelToKebab = camelToKebab;
	exports.getWindowHeight = getWindowHeight;
	exports.getDocumentHeight = getDocumentHeight;
	exports.parse = parse;
	exports.makeStyleTag = makeStyleTag;
	exports.injectStyles = injectStyles;
	exports.insertStyleTag = insertStyleTag;
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	}
	
	// `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	function isTouchDevice() {
	  if (typeof window === 'undefined' || !window) return false;
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function getPadding() {
	  if (typeof window === 'undefined' || !window || !document) return 0;
	
	  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
	  var clientWidth = document.body ? document.body.clientWidth : 0;
	  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	
	  return adjustedPadding;
	}
	
	function camelToKebab(str) {
	  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	
	function getWindowHeight() {
	  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (typeof window !== 'undefined' && window && window.innerHeight) {
	    return window.innerHeight * multiplier;
	  }
	}
	
	function getDocumentHeight() {
	  if (typeof window !== 'undefined' && document && document.body) {
	    return document.body.clientHeight;
	  }
	}
	
	function parse(val) {
	  return isNaN(val) ? val : val + 'px';
	}
	
	// ==============================
	// Style Sheets
	// ==============================
	
	function makeStyleTag(id) {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-react-scrolllock', '');
	
	  return tag;
	}
	function injectStyles(tag, css) {
	  if (tag.styleSheet) {
	    tag.styleSheet.cssText = css;
	  } else {
	    tag.appendChild(document.createTextNode(css));
	  }
	}
	function insertStyleTag(tag) {
	  var head = document.head || document.getElementsByTagName('head')[0];
	  head.appendChild(tag);
	}

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTouchListeners;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(49);
	
	var _utils = __webpack_require__(214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withTouchListeners(WrappedComponent) {
	  return function (_PureComponent) {
	    _inherits(TouchProvider, _PureComponent);
	
	    function TouchProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TouchProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
	        capture: false,
	        passive: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TouchProvider, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // account for touch devices
	        if (target && (0, _utils.isTouchDevice)()) {
	          // Mobile Safari ignores { overflow: hidden } declaration on the body.
	          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          // Allow scroll on provided target
	          if (touchScrollTarget) {
	            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // remove touch listeners
	        if (target && (0, _utils.isTouchDevice)()) {
	          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          if (touchScrollTarget) {
	            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	    }]);
	
	    return TouchProvider;
	  }(_react.PureComponent);
	}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(49));
	var shallowEqual = _interopDefault(__webpack_require__(546));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 546:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	    module.exports['default'] = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('slugify', this, function () {
	  /* eslint-disable */
	  var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
	  /* eslint-enable */
	
	  function replace (string, options) {
	    if (typeof string !== 'string') {
	      throw new Error('slugify: string argument expected')
	    }
	
	    options = (typeof options === 'string')
	      ? {replacement: options}
	      : options || {}
	
	    var slug = string.split('')
	      .reduce(function (result, ch) {
	        return result + (charMap[ch] || ch)
	          // allowed
	          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
	      }, '')
	      // trim leading/trailing spaces
	      .trim()
	      // convert spaces
	      .replace(/[-\s]+/g, options.replacement || '-')
	      // remove trailing separator
	      .replace('#{replacement}$', '')
	
	    return options.lower ? slug.toLowerCase() : slug
	  }
	
	  replace.extend = function (customMap) {
	    for (var key in customMap) {
	      charMap[key] = customMap[key]
	    }
	  }
	
	  return replace
	}))


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSpriteSymbol = factory());
	}(this, (function () { 'use strict';
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	return BrowserSpriteSymbol;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSprite = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	//      
	// An event handler can take an optional event argument
	// and should not return a value
	                                          
	// An array of all currently registered event handlers for a type
	                                            
	// A map of event types and their corresponding event handlers.
	                        
	                                   
	  
	
	/** Mitt: Tiny (~200b) functional event emitter / pubsub.
	 *  @name mitt
	 *  @returns {Mitt}
	 */
	function mitt(all                 ) {
		all = all || Object.create(null);
	
		return {
			/**
			 * Register an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to listen for, or `"*"` for all events
			 * @param  {Function} handler Function to call in response to given event
			 * @memberOf mitt
			 */
			on: function on(type        , handler              ) {
				(all[type] || (all[type] = [])).push(handler);
			},
	
			/**
			 * Remove an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
			 * @param  {Function} handler Handler function to remove
			 * @memberOf mitt
			 */
			off: function off(type        , handler              ) {
				if (all[type]) {
					all[type].splice(all[type].indexOf(handler) >>> 0, 1);
				}
			},
	
			/**
			 * Invoke all handlers for the given type.
			 * If present, `"*"` handlers are invoked after type-matched handlers.
			 *
			 * @param {String} type  The event type to invoke
			 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
			 * @memberof mitt
			 */
			emit: function emit(type        , evt     ) {
				(all[type] || []).map(function (handler) { handler(evt); });
				(all['*'] || []).map(function (handler) { handler(type, evt); });
			}
		};
	}
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var svg$1 = namespaces_1.svg;
	var xlink$1 = namespaces_1.xlink;
	
	var defaultConfig = {
	  attrs: ( obj = {
	    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
	  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
	};
	var obj;
	
	var Sprite = function Sprite(config) {
	  this.config = deepmerge(defaultConfig, config || {});
	  this.symbols = [];
	};
	
	/**
	 * Add new symbol. If symbol with the same id exists it will be replaced.
	 * @param {SpriteSymbol} symbol
	 * @return {boolean} `true` - symbol was added, `false` - replaced
	 */
	Sprite.prototype.add = function add (symbol) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var existing = this.find(symbol.id);
	
	  if (existing) {
	    symbols[symbols.indexOf(existing)] = symbol;
	    return false;
	  }
	
	  symbols.push(symbol);
	  return true;
	};
	
	/**
	 * Remove symbol & destroy it
	 * @param {string} id
	 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
	 */
	Sprite.prototype.remove = function remove (id) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var symbol = this.find(id);
	
	  if (symbol) {
	    symbols.splice(symbols.indexOf(symbol), 1);
	    symbol.destroy();
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * @param {string} id
	 * @return {SpriteSymbol|null}
	 */
	Sprite.prototype.find = function find (id) {
	  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
	};
	
	/**
	 * @param {string} id
	 * @return {boolean}
	 */
	Sprite.prototype.has = function has (id) {
	  return this.find(id) !== null;
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.stringify = function stringify () {
	  var ref = this.config;
	    var attrs = ref.attrs;
	  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
	  return wrapInSvgString(stringifiedSymbols, attrs);
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	Sprite.prototype.destroy = function destroy () {
	  this.symbols.forEach(function (s) { return s.destroy(); });
	};
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	var defaultConfig$1 = {
	  /**
	   * Should following options be automatically configured:
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @type {boolean}
	   */
	  autoConfigure: true,
	
	  /**
	   * Default mounting selector
	   * @type {string}
	   */
	  mountTo: 'body',
	
	  /**
	   * Fix disappearing SVG elements when <base href> exists.
	   * Executes when sprite mounted.
	   * @see http://stackoverflow.com/a/18265336/796152
	   * @see https://github.com/everdimension/angular-svg-base-fix
	   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
	   * @type {boolean}
	   */
	  syncUrlsWithBaseTag: false,
	
	  /**
	   * Should sprite listen custom location change event
	   * @type {boolean}
	   */
	  listenLocationChangeEvent: true,
	
	  /**
	   * Custom window event name which should be emitted to update sprite urls
	   * @type {string}
	   */
	  locationChangeEvent: 'locationChange',
	
	  /**
	   * Emit location change event in Angular automatically
	   * @type {boolean}
	   */
	  locationChangeAngularEmitter: false,
	
	  /**
	   * Selector to find symbols usages when updating sprite urls
	   * @type {string}
	   */
	  usagesToUpdate: 'use[*|href]',
	
	  /**
	   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
	   * Executes when sprite is rendered, but not mounted.
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
	   * @type {boolean}
	   */
	  moveGradientsOutsideSymbol: false
	};
	
	/**
	 * @param {*} arrayLike
	 * @return {Array}
	 */
	var arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	};
	
	var ua = navigator.userAgent;
	
	var browser = {
	  isChrome: /chrome/i.test(ua),
	  isFirefox: /firefox/i.test(ua),
	
	  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	  isIE: /msie/i.test(ua) || /trident/i.test(ua),
	  isEdge: /edge/i.test(ua)
	};
	
	/**
	 * @param {string} name
	 * @param {*} data
	 */
	var dispatchEvent = function (name, data) {
	  var event = document.createEvent('CustomEvent');
	  event.initCustomEvent(name, false, false, data);
	  window.dispatchEvent(event);
	};
	
	/**
	 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
	 * This trick will trigger IE to read and use any existing SVG <style> tags.
	 * @see https://github.com/iconic/SVGInjector/issues/23
	 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
	 *
	 * @param {Element} node DOM Element to search <style> tags in
	 * @return {Array<HTMLStyleElement>}
	 */
	var evalStylesIEWorkaround = function (node) {
	  var updatedNodes = [];
	
	  arrayFrom(node.querySelectorAll('style'))
	    .forEach(function (style) {
	      style.textContent += '';
	      updatedNodes.push(style);
	    });
	
	  return updatedNodes;
	};
	
	/**
	 * @param {string} [url] If not provided - current URL will be used
	 * @return {string}
	 */
	var getUrlWithoutFragment = function (url) {
	  return (url || window.location.href).split('#')[0];
	};
	
	/* global angular */
	/**
	 * @param {string} eventName
	 */
	var locationChangeAngularEmitter = function (eventName) {
	  angular.module('ng').run(['$rootScope', function ($rootScope) {
	    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
	      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
	    });
	  }]);
	};
	
	var defaultSelector = 'linearGradient, radialGradient, pattern';
	
	/**
	 * @param {Element} svg
	 * @param {string} [selector]
	 * @return {Element}
	 */
	var moveGradientsOutsideSymbol = function (svg, selector) {
	  if ( selector === void 0 ) selector = defaultSelector;
	
	  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
	    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
	      symbol.parentNode.insertBefore(node, symbol);
	    });
	  });
	  return svg;
	};
	
	/**
	 * @param {NodeList} nodes
	 * @param {Function} [matcher]
	 * @return {Attr[]}
	 */
	function selectAttributes(nodes, matcher) {
	  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
	    if (!node.attributes) {
	      return acc;
	    }
	
	    var arrayfied = arrayFrom(node.attributes);
	    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
	    return acc.concat(matched);
	  }, []);
	
	  return attrs;
	}
	
	/**
	 * @param {NodeList|Node} nodes
	 * @param {boolean} [clone=true]
	 * @return {string}
	 */
	
	var xLinkNS = namespaces_1.xlink.uri;
	var xLinkAttrName = 'xlink:href';
	
	// eslint-disable-next-line no-useless-escape
	var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;
	
	function encoder(url) {
	  return url.replace(specialUrlCharsPattern, function (match) {
	    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
	  });
	}
	
	/**
	 * @param {NodeList} nodes
	 * @param {string} startsWith
	 * @param {string} replaceWith
	 * @return {NodeList}
	 */
	function updateReferences(nodes, startsWith, replaceWith) {
	  arrayFrom(nodes).forEach(function (node) {
	    var href = node.getAttribute(xLinkAttrName);
	    if (href && href.indexOf(startsWith) === 0) {
	      var newUrl = href.replace(startsWith, replaceWith);
	      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
	    }
	  });
	
	  return nodes;
	}
	
	/**
	 * List of SVG attributes to update url() target in them
	 */
	var attList = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke',
	  'style'
	];
	
	var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');
	
	/**
	 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
	 * @param {Element} svg
	 * @param {NodeList} references
	 * @param {string|RegExp} startsWith
	 * @param {string} replaceWith
	 * @return {void}
	 *
	 * @example
	 * const sprite = document.querySelector('svg.sprite');
	 * const usages = document.querySelectorAll('use');
	 * updateUrls(sprite, usages, '#', 'prefix#');
	 */
	var updateUrls = function (svg, references, startsWith, replaceWith) {
	  var startsWithEncoded = encoder(startsWith);
	  var replaceWithEncoded = encoder(replaceWith);
	
	  var nodes = svg.querySelectorAll(attSelector);
	  var attrs = selectAttributes(nodes, function (ref) {
	    var localName = ref.localName;
	    var value = ref.value;
	
	    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
	  });
	
	  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
	  updateReferences(references, startsWithEncoded, replaceWithEncoded);
	};
	
	/**
	 * Internal emitter events
	 * @enum
	 * @private
	 */
	var Events = {
	  MOUNT: 'mount',
	  SYMBOL_MOUNT: 'symbol_mount'
	};
	
	var BrowserSprite = (function (Sprite$$1) {
	  function BrowserSprite(cfg) {
	    var this$1 = this;
	    if ( cfg === void 0 ) cfg = {};
	
	    Sprite$$1.call(this, deepmerge(defaultConfig$1, cfg));
	
	    var emitter = mitt();
	    this._emitter = emitter;
	    this.node = null;
	
	    var ref = this;
	    var config = ref.config;
	
	    if (config.autoConfigure) {
	      this._autoConfigure(cfg);
	    }
	
	    if (config.syncUrlsWithBaseTag) {
	      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
	      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
	    }
	
	    var handleLocationChange = this._handleLocationChange.bind(this);
	    this._handleLocationChange = handleLocationChange;
	
	    // Provide way to update sprite urls externally via dispatching custom window event
	    if (config.listenLocationChangeEvent) {
	      window.addEventListener(config.locationChangeEvent, handleLocationChange);
	    }
	
	    // Emit location change event in Angular automatically
	    if (config.locationChangeAngularEmitter) {
	      locationChangeAngularEmitter(config.locationChangeEvent);
	    }
	
	    // After sprite mounted
	    emitter.on(Events.MOUNT, function (spriteNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(spriteNode);
	      }
	    });
	
	    // After symbol mounted into sprite
	    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(symbolNode.parentNode);
	      }
	
	      if (browser.isIE || browser.isEdge) {
	        evalStylesIEWorkaround(symbolNode);
	      }
	    });
	  }
	
	  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
	  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
	  BrowserSprite.prototype.constructor = BrowserSprite;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  /**
	   * @return {boolean}
	   */
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * Automatically configure following options
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @param {Object} cfg
	   * @private
	   */
	  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
	    var ref = this;
	    var config = ref.config;
	
	    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
	      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
	    }
	
	    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
	      config.locationChangeAngularEmitter = 'angular' in window;
	    }
	
	    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
	      config.moveGradientsOutsideSymbol = browser.isFirefox;
	    }
	  };
	
	  /**
	   * @param {Event} event
	   * @param {Object} event.detail
	   * @param {string} event.detail.oldUrl
	   * @param {string} event.detail.newUrl
	   * @private
	   */
	  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
	    var ref = event.detail;
	    var oldUrl = ref.oldUrl;
	    var newUrl = ref.newUrl;
	    this.updateUrls(oldUrl, newUrl);
	  };
	
	  /**
	   * Add new symbol. If symbol with the same id exists it will be replaced.
	   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
	   * @fires Events#SYMBOL_MOUNT
	   * @param {BrowserSpriteSymbol} symbol
	   * @return {boolean} `true` - symbol was added, `false` - replaced
	   */
	  BrowserSprite.prototype.add = function add (symbol) {
	    var sprite = this;
	    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);
	
	    if (this.isMounted && isNewSymbol) {
	      symbol.mount(sprite.node);
	      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    }
	
	    return isNewSymbol;
	  };
	
	  /**
	   * Attach to existing DOM node
	   * @param {string|Element} target
	   * @return {Element|null} attached DOM Element. null if node to attach not found.
	   */
	  BrowserSprite.prototype.attach = function attach (target) {
	    var this$1 = this;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    /** @type Element */
	    var node = typeof target === 'string' ? document.querySelector(target) : target;
	    sprite.node = node;
	
	    // Already added symbols needs to be mounted
	    this.symbols.forEach(function (symbol) {
	      symbol.mount(sprite.node);
	      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    });
	
	    // Create symbols from existing DOM nodes, add and mount them
	    arrayFrom(node.querySelectorAll('symbol'))
	      .forEach(function (symbolNode) {
	        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
	        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
	        sprite.add(symbol);
	      });
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  BrowserSprite.prototype.destroy = function destroy () {
	    var ref = this;
	    var config = ref.config;
	    var symbols = ref.symbols;
	    var _emitter = ref._emitter;
	
	    symbols.forEach(function (s) { return s.destroy(); });
	
	    _emitter.off('*');
	    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);
	
	    if (this.isMounted) {
	      this.unmount();
	    }
	  };
	
	  /**
	   * @fires Events#MOUNT
	   * @param {string|Element} [target]
	   * @param {boolean} [prepend=false]
	   * @return {Element|null} rendered sprite node. null if mount node not found.
	   */
	  BrowserSprite.prototype.mount = function mount (target, prepend) {
	    if ( target === void 0 ) target = this.config.mountTo;
	    if ( prepend === void 0 ) prepend = false;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = sprite.render();
	    this.node = node;
	
	    if (prepend && mountNode.childNodes[0]) {
	      mountNode.insertBefore(node, mountNode.childNodes[0]);
	    } else {
	      mountNode.appendChild(node);
	    }
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSprite.prototype.render = function render () {
	    return parse(this.stringify());
	  };
	
	  /**
	   * Detach sprite from the DOM
	   */
	  BrowserSprite.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  /**
	   * Update URLs in sprite and usage elements
	   * @param {string} oldUrl
	   * @param {string} newUrl
	   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
	   */
	  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
	    if (!this.isMounted) {
	      return false;
	    }
	
	    var usages = document.querySelectorAll(this.config.usagesToUpdate);
	
	    updateUrls(
	      this.node,
	      usages,
	      ((getUrlWithoutFragment(oldUrl)) + "#"),
	      ((getUrlWithoutFragment(newUrl)) + "#")
	    );
	
	    return true;
	  };
	
	  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );
	
	  return BrowserSprite;
	}(Sprite));
	
	var ready$1 = createCommonjsModule(function (module) {
	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  { module.exports = definition(); }
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);
	
	
	  if (!loaded)
	  { doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener);
	    loaded = 1;
	    while (listener = fns.shift()) { listener(); }
	  }); }
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn);
	  }
	
	});
	});
	
	var spriteNodeId = '__SVG_SPRITE_NODE__';
	var spriteGlobalVarName = '__SVG_SPRITE__';
	var isSpriteExists = !!window[spriteGlobalVarName];
	
	// eslint-disable-next-line import/no-mutable-exports
	var sprite;
	
	if (isSpriteExists) {
	  sprite = window[spriteGlobalVarName];
	} else {
	  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
	  window[spriteGlobalVarName] = sprite;
	}
	
	var loadSprite = function () {
	  /**
	   * Check for page already contains sprite node
	   * If found - attach to and reuse it's content
	   * If not - render and mount the new sprite
	   */
	  var existing = document.getElementById(spriteNodeId);
	
	  if (existing) {
	    sprite.attach(existing);
	  } else {
	    sprite.mount(document.body, true);
	  }
	};
	
	if (document.body) {
	  loadSprite();
	} else {
	  ready$1(loadSprite);
	}
	
	var sprite$1 = sprite;
	
	return sprite$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(24);
	var sprite = __webpack_require__(25);
	var symbol = new SpriteSymbol({
	  "id": "light",
	  "use": "light-usage",
	  "viewBox": "0 0 58 58",
	  "content": "<symbol viewBox=\"0 0 58 58\" id=\"light\">\n  <defs>\n    <linearGradient id=\"light_light-c\" x1=\"50%\" x2=\"50%\" y1=\"0%\" y2=\"100%\">\n      <stop offset=\"0%\" stop-color=\"#32A7CF\" />\n      <stop offset=\"100%\" stop-color=\"#2886A6\" />\n    </linearGradient>\n    <circle id=\"light_light-b\" cx=\"24\" cy=\"24\" r=\"24\" />\n    <filter id=\"light_light-a\" width=\"135.4%\" height=\"135.4%\" x=\"-17.7%\" y=\"-13.5%\" filterUnits=\"objectBoundingBox\">\n      <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n      <feMorphology in=\"SourceAlpha\" radius=\"4\" result=\"shadowInner\"></feMorphology>\n      <feOffset dy=\"2\" in=\"shadowInner\" result=\"shadowInner\"></feOffset>\n      <feComposite in=\"shadowOffsetOuter1\" in2=\"shadowInner\" operator=\"out\" result=\"shadowOffsetOuter1\"></feComposite>\n      <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2.5\"></feGaussianBlur>\n      <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0\"></feColorMatrix>\n    </filter>\n    <path id=\"light_light-e\" d=\"M34.6158713,24.8880545 C35.101271,26.1492438 35.3672738,27.518881 35.3672738,28.9504827 C35.3672738,29.9572888 35.2357109,30.7869079 34.9887961,31.4702896 L35.6305059,31.4702896 C36.1827907,31.4702896 36.6305059,31.9180049 36.6305059,32.4702896 L36.6305059,34.25 C36.6305059,34.8022847 36.1827907,35.25 35.6305059,35.25 L12.3658644,35.25 C11.8135796,35.25 11.3658644,34.8022847 11.3658644,34.25 L11.3658644,32.4702896 C11.3658644,31.9180049 11.8135796,31.4702896 12.3658644,31.4702896 L13.0075741,31.4702896 C12.7606594,30.7869079 12.6290964,29.9572888 12.6290964,28.9504827 C12.6290964,27.573068 12.8753436,26.2530159 13.3263264,25.0317286 C12.3685533,24.2246975 11.573354,23.3385333 10.9407285,22.3732359 C9.33283822,19.919822 12.6090986,10.8719233 13.0743197,13.3715697 C13.6661465,16.5514719 15.2615934,18.5622628 17.8606606,19.4039423 C19.6310207,18.2694107 21.7375509,17.6113517 23.9981851,17.6113517 C26.1724762,17.6113517 28.2042103,18.2201026 29.9313962,19.2760401 C32.653468,18.4754987 34.3182294,16.4433024 34.9256803,13.1794514 C35.3909014,10.6798049 38.6671618,19.7277036 37.0592715,22.1811175 C36.4139627,23.1657678 35.5994959,24.0680802 34.6158713,24.8880545 Z\" />\n    <filter id=\"light_light-d\" width=\"163%\" height=\"175.6%\" x=\"-31.5%\" y=\"-28.9%\" filterUnits=\"objectBoundingBox\">\n      <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n      <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2.5\"></feGaussianBlur>\n      <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0\"></feColorMatrix>\n    </filter>\n  </defs>\n  <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(5 3)\">\n    <use fill=\"#000\" filter=\"url(#light_light-a)\" xlink:href=\"#light_light-b\" />\n    <circle cx=\"24\" cy=\"24\" r=\"22\" stroke=\"url(#light_light-c)\" stroke-width=\"4\" />\n    <g>\n      <use fill=\"#000\" filter=\"url(#light_light-d)\" xlink:href=\"#light_light-e\" />\n      <use fill=\"url(#light_light-c)\" xlink:href=\"#light_light-e\" />\n    </g>\n  </g>\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  margin-top: 3rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"], ["\n  background: ", ";\n  margin-top: 3rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  max-width: 64rem;\n  width: 100%;\n  padding: 3rem 0;\n  @media screen and (max-width: 64em) {\n    padding: 3rem 2rem;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  max-width: 64rem;\n  width: 100%;\n  padding: 3rem 0;\n  @media screen and (max-width: 64em) {\n    padding: 3rem 2rem;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: rgba(255, 255, 255, 0.9);\n  font-family: Futura;\n  font-size: 22px;\n  font-weight: 500;\n  letter-spacing: 1.1px;\n  line-height: 30px;\n  text-decoration: none;\n  text-transform: uppercase;\n"], ["\n  color: rgba(255, 255, 255, 0.9);\n  font-family: Futura;\n  font-size: 22px;\n  font-weight: 500;\n  letter-spacing: 1.1px;\n  line-height: 30px;\n  text-decoration: none;\n  text-transform: uppercase;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 64em) {\n    width: 45%;\n    margin-bottom: 2rem;\n  }\n  @media screen and (max-width: 375px) {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 64em) {\n    width: 45%;\n    margin-bottom: 2rem;\n  }\n  @media screen and (max-width: 375px) {\n    width: 100%;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  color: rgba(255, 255, 255, 0.8);\n  font-family: Lato;\n  font-size: 16px;\n  letter-spacing: 1.2px;\n  line-height: 19px;\n  text-decoration: none;\n  font-weight: 400;\n  margin: 0.25rem 0;\n"], ["\n  color: rgba(255, 255, 255, 0.8);\n  font-family: Lato;\n  font-size: 16px;\n  letter-spacing: 1.2px;\n  line-height: 19px;\n  text-decoration: none;\n  font-weight: 400;\n  margin: 0.25rem 0;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.footer(_templateObject, _baseStyles2.default.color.blueGradient);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var CategoryTitle = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3);
	
	var CategoryWrapper = _styledComponents2.default.div(_templateObject4);
	
	var SubTitle = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5);
	
	var renderCategories = function renderCategories(aboutMenu, eventTypes, jobRoles) {
	  var menuItems = [{
	    name: "Nordics",
	    slug: "/nordics",
	    items: [{
	      name: "Overview",
	      slug: "/nordics/overview"
	    }, {
	      name: "Sweden",
	      slug: "/nordics/sweden"
	    }, {
	      name: "Norway",
	      slug: "/nordics/norway"
	    }, {
	      name: "Iceland",
	      slug: "/nordics/iceland"
	    }, {
	      name: "Finland",
	      slug: "/nordics/finland"
	    }, {
	      name: "Denmark",
	      slug: "/nordics/denmark"
	    }]
	  }, {
	    name: "Jobs",
	    slug: "/jobs",
	    items: jobRoles
	  }, {
	    name: "Events",
	    slug: "/events",
	    items: eventTypes
	  }, {
	    name: "About",
	    slug: "/about",
	    items: aboutMenu
	  }];
	
	  return menuItems.map(function (_ref) {
	    var name = _ref.name,
	        slug = _ref.slug,
	        items = _ref.items;
	
	    var renderItems = items && items.map(function (subItem) {
	      return _react2.default.createElement(
	        SubTitle,
	        { key: subItem.name, to: subItem.slug },
	        subItem.name
	      );
	    });
	    return _react2.default.createElement(
	      CategoryWrapper,
	      { key: name },
	      _react2.default.createElement(
	        CategoryTitle,
	        { to: slug },
	        name
	      ),
	      renderItems
	    );
	  });
	};
	
	var Footer = function Footer(_ref2) {
	  var aboutMenu = _ref2.aboutMenu,
	      eventTypes = _ref2.eventTypes,
	      jobRoles = _ref2.jobRoles;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      renderCategories(aboutMenu, eventTypes, jobRoles)
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  :not(:last-of-type) {\n    margin-right: 4rem;\n  }\n  @media screen and (max-width: 48em) {\n    :not(:last-of-type) {\n      margin-right: 2rem;\n    }\n  }\n  > a {\n    color: ", ";\n    font-family: Lato;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    text-align: center;\n    font-size: 0.9375rem;\n    font-weight: 400;\n    text-decoration: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  :not(:last-of-type) {\n    margin-right: 4rem;\n  }\n  @media screen and (max-width: 48em) {\n    :not(:last-of-type) {\n      margin-right: 2rem;\n    }\n  }\n  > a {\n    color: ", ";\n    font-family: Lato;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    text-align: center;\n    font-size: 0.9375rem;\n    font-weight: 400;\n    text-decoration: none;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 4rem;\n  width: 100%;\n  position: relative;\n  z-index: 500;\n  background: transparent;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 4rem;\n  width: 100%;\n  position: relative;\n  z-index: 500;\n  background: transparent;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 64rem;\n  width: 100%;\n  @media screen and (max-width: 64em) {\n    padding: 0 2rem;\n  }\n  @media screen and (max-width: 20em) {\n    padding: 0 1rem;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 64rem;\n  width: 100%;\n  @media screen and (max-width: 64em) {\n    padding: 0 2rem;\n  }\n  @media screen and (max-width: 20em) {\n    padding: 0 1rem;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  list-style: none;\n  padding: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  list-style: none;\n  padding: 0;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  height: 100%;\n  width: 14rem;\n  top: 0;\n  right: 0;\n  background: ", ";\n  box-shadow: ", ";\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  transform: ", ";\n  transition: all 0.4s ease;\n  z-index: 10000;\n"], ["\n  position: fixed;\n  height: 100%;\n  width: 14rem;\n  top: 0;\n  right: 0;\n  background: ", ";\n  box-shadow: ", ";\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  transform: ", ";\n  transition: all 0.4s ease;\n  z-index: 10000;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  text-align: left;\n  font-size: 1rem;\n  font-weight: 400;\n  text-decoration: none;\n  color: white;\n  margin-bottom: 1.25rem;\n"], ["\n  font-family: Lato;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  text-align: left;\n  font-size: 1rem;\n  font-weight: 400;\n  text-decoration: none;\n  color: white;\n  margin-bottom: 1.25rem;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactResponsive = __webpack_require__(87);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactHamburgerMenu = __webpack_require__(495);
	
	var _reactHamburgerMenu2 = _interopRequireDefault(_reactHamburgerMenu);
	
	var _reactOutsideClickHandler = __webpack_require__(513);
	
	var _reactOutsideClickHandler2 = _interopRequireDefault(_reactOutsideClickHandler);
	
	var _reactScrolllock = __webpack_require__(522);
	
	var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);
	
	var _light = __webpack_require__(549);
	
	var _light2 = _interopRequireDefault(_light);
	
	var _Icon = __webpack_require__(26);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MenuItem = _styledComponents2.default.li(_templateObject, _baseStyles2.default.color.lightGray);
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject2);
	
	var HeaderContent = _styledComponents2.default.div(_templateObject3);
	
	var BrandLogo = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4);
	
	var HeaderMenu = _styledComponents2.default.ul(_templateObject5);
	
	var Menu = _styledComponents2.default.nav(_templateObject6, _baseStyles2.default.color.blueGradient, _baseStyles2.default.layers.l5, function (props) {
	  return props.isOpen ? "translateX(0)" : "translateX(20rem)";
	});
	
	var SideMenuItem = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject7);
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      menuItems: [{
	        name: "Home",
	        route: "/"
	      }, {
	        name: "Jobs",
	        route: "/jobs"
	      }, {
	        name: "Events",
	        route: "/events"
	      }, {
	        name: "Nordics",
	        route: "/nordics"
	      }, {
	        name: "About",
	        route: "/about"
	      }],
	      isOpen: false
	    }, _this.onMenuItemClick = function (route) {
	      _this.setState(function (prevState) {
	        return {
	          isOpen: !prevState.isOpen
	        };
	      });
	      (0, _gatsbyLink.navigateTo)(route);
	    }, _this.handleClick = function () {
	      _this.setState(function (prevState) {
	        return {
	          isOpen: !prevState.isOpen
	        };
	      });
	    }, _this.onOutsideClick = function () {
	      if (_this.state.isOpen) {
	        _this.handleClick();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.renderMenu = function renderMenu() {
	    return this.state.menuItems.map(function (_ref) {
	      var name = _ref.name,
	          route = _ref.route;
	
	      return _react2.default.createElement(
	        MenuItem,
	        { key: name },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: route,
	            exact: route === "/",
	            activeStyle: { color: _baseStyles2.default.color.primary }
	          },
	          name
	        )
	      );
	    });
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      HeaderWrapper,
	      null,
	      _react2.default.createElement(
	        HeaderContent,
	        null,
	        _react2.default.createElement(
	          BrandLogo,
	          { to: "/" },
	          _react2.default.createElement(_Icon2.default, { iconRef: _light2.default, size: 3 })
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { query: "(min-width: 426px)" },
	          _react2.default.createElement(
	            HeaderMenu,
	            null,
	            this.renderMenu()
	          )
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { query: "(max-width: 425px)" },
	          _react2.default.createElement(_reactHamburgerMenu2.default, {
	            isOpen: this.state.isOpen,
	            menuClicked: this.handleClick,
	            width: 20,
	            height: 14,
	            strokeWidth: 2,
	            rotate: 0,
	            color: _baseStyles2.default.color.lightGray,
	            borderRadius: 1,
	            animationDuration: 0.5
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { query: "(max-width: 425px)" },
	        _react2.default.createElement(
	          _reactOutsideClickHandler2.default,
	          { onOutsideClick: this.onOutsideClick },
	          _react2.default.createElement(
	            Menu,
	            { isOpen: this.state.isOpen },
	            this.state.isOpen && _react2.default.createElement(_reactScrolllock2.default, null),
	            _react2.default.createElement(
	              "div",
	              { style: { alignSelf: "flex-end", marginBottom: "2rem" } },
	              _react2.default.createElement(_reactHamburgerMenu2.default, {
	                isOpen: this.state.isOpen,
	                menuClicked: this.handleClick,
	                width: 20,
	                height: 14,
	                strokeWidth: 2,
	                rotate: 0,
	                color: "#fff",
	                borderRadius: 1,
	                animationDuration: 0.5
	              })
	            ),
	            this.state.menuItems.map(function (_ref2) {
	              var name = _ref2.name,
	                  route = _ref2.route;
	              return _react2.default.createElement(
	                SideMenuItem,
	                {
	                  exact: route === "/",
	                  key: name,
	                  to: route,
	                  activeStyle: { textDecoration: "underline" },
	                  onClick: function onClick() {
	                    return _this2.onMenuItemClick(route);
	                  }
	                },
	                name
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PartnersBar = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  max-width: 64rem;\n  width: 100%;\n  height: 16rem;\n  padding: 3rem 0;\n  margin: 2rem auto;\n  align-items: center;\n\n  @media screen and (max-width: 64em) {\n  }\n"], ["\n  position: relative;\n  max-width: 64rem;\n  width: 100%;\n  height: 16rem;\n  padding: 3rem 0;\n  margin: 2rem auto;\n  align-items: center;\n\n  @media screen and (max-width: 64em) {\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  100% { \n    transform: translateX(-", "px);  \n  }\n"], ["\n  100% { \n    transform: translateX(-", "px);  \n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  min-width: 100%;\n  height: 5rem;\n  animation: ", " 10s linear infinite;\n"], ["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  min-width: 100%;\n  height: 5rem;\n  animation: ", " 10s linear infinite;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"], ["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-align: center;\n"], ["\n  color: ", ";\n  text-align: center;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphcmsImage = __webpack_require__(50);
	
	var _graphcmsImage2 = _interopRequireDefault(_graphcmsImage);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LogoSlide = function LogoSlide(_ref) {
	  var image = _ref.image,
	      alt = _ref.alt;
	
	  return _react2.default.createElement(_graphcmsImage2.default, {
	    withWebp: true,
	    image: image,
	    blurryPlaceholder: false,
	    "max-width": 160,
	    alt: alt,
	    style: {
	      flex: 1,
	      heigth: "100%",
	      width: 160,
	      margin: "0 5rem"
	    }
	  });
	};
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var moveSlideshow = function moveSlideshow(width) {
	  return (0, _styledComponents.keyframes)(_templateObject2, width);
	};
	
	var Wrapper = _styledComponents2.default.div(_templateObject3, function (props) {
	  return moveSlideshow(props.length * 320);
	});
	
	var Title = _styledComponents2.default.h2(_templateObject4);
	
	var TitleDark = Title.extend(_templateObject5, _baseStyles2.default.color.darkGray);
	
	var PartnersBar = exports.PartnersBar = function (_Component) {
	  _inherits(PartnersBar, _Component);
	
	  function PartnersBar() {
	    _classCallCheck(this, PartnersBar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PartnersBar.prototype.render = function render() {
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        TitleDark,
	        null,
	        "Our Partners"
	      ),
	      _react2.default.createElement(
	        Wrapper,
	        { length: this.props.partners.length },
	        this.props.partners.map(function (_ref2) {
	          var node = _ref2.node;
	
	          return _react2.default.createElement(
	            "a",
	            { key: "loop1-" + node.id, href: node.link, target: "__blank" },
	            _react2.default.createElement(LogoSlide, { image: node.logo, alt: node.name })
	          );
	        }),
	        this.props.partners.map(function (_ref3) {
	          var node = _ref3.node;
	
	          return _react2.default.createElement(
	            "a",
	            { key: "loop2-" + node.id, href: node.link, target: "__blank" },
	            _react2.default.createElement(LogoSlide, { image: node.logo, alt: node.name })
	          );
	        })
	      )
	    );
	  };
	
	  return PartnersBar;
	}(_react.Component);
	
	exports.default = PartnersBar;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: ", "rem;\n  height: ", "rem;\n  fill: ", ";\n"], ["\n  width: ", "rem;\n  height: ", "rem;\n  fill: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IconSVG = _styledComponents2.default.svg(_templateObject, function (props) {
	  return props.size;
	}, function (props) {
	  return props.size;
	}, function (props) {
	  return props.color || _baseStyles2.default.color.lightGray;
	});
	
	var Icon = function Icon(_ref) {
	  var iconRef = _ref.iconRef,
	      size = _ref.size,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ["iconRef", "size", "color"]);
	
	  return _react2.default.createElement(
	    IconSVG,
	    _extends({ size: size, color: color }, props),
	    _react2.default.createElement("use", { xlinkHref: "#" + iconRef.id })
	  );
	};
	
	exports.default = Icon;
	module.exports = exports["default"];

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.AboutMenuQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-image: linear-gradient(-180deg, #ffffff 0%, #e6eaeb 100%);\n  overflow-x: hidden;\n  min-height: 100vh;\n"], ["\n  background-image: linear-gradient(-180deg, #ffffff 0%, #e6eaeb 100%);\n  overflow-x: hidden;\n  min-height: 100vh;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 100%;\n"], ["\n  display: flex;\n  height: 100%;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(496);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Header = __webpack_require__(285);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	__webpack_require__(488);
	
	var _Footer = __webpack_require__(284);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _slugify = __webpack_require__(130);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _PartnersBar = __webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Body = _styledComponents2.default.div(_templateObject);
	
	var PageWrapper = _styledComponents2.default.div(_templateObject2);
	
	var loadAboutMenu = function loadAboutMenu(pages) {
	  return pages.map(function (_ref) {
	    var pageTitle = _ref.node.pageTitle;
	
	    var slug = "/about/" + (0, _slugify2.default)(pageTitle, { lower: true });
	    return {
	      name: pageTitle,
	      slug: slug
	    };
	  });
	};
	
	var eventTypes = function eventTypes(events) {
	  return Array.from(new Set(events.map(function (_ref2) {
	    var node = _ref2.node;
	    return node.eventType;
	  }))).map(function (eventType) {
	    return { name: eventType, slug: "/events" };
	  });
	};
	
	var jobRoles = function jobRoles(jobs) {
	  return Array.from(new Set(jobs.map(function (_ref3) {
	    var node = _ref3.node;
	    return node.role;
	  }))).slice(0, 10).map(function (role) {
	    return { name: role, slug: "/jobs" };
	  });
	};
	
	var TemplateWrapper = function TemplateWrapper(_ref4) {
	  var data = _ref4.data,
	      children = _ref4.children;
	  return _react2.default.createElement(
	    Body,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { charset: "utf-8" }),
	      _react2.default.createElement(
	        "title",
	        null,
	        "Move To Nordics"
	      ),
	      _react2.default.createElement("meta", { name: "description", content: "Your portal to the best tech ecosystem in the world." }),
	      _react2.default.createElement("meta", { name: "image", content: "https://media.graphcms.com/resize=w:1600,fit:crop/output=format:jpg/compress/2Lv82o4zTZmoXnHx4hr7" }),
	      _react2.default.createElement("meta", { itemprop: "name", content: "Move To Nordics" }),
	      _react2.default.createElement("meta", { itemprop: "description", content: "Your portal to the best tech ecosystem in the world." }),
	      _react2.default.createElement("meta", { itemprop: "image", content: "https://media.graphcms.com/resize=w:1600,fit:crop/output=format:jpg/compress/2Lv82o4zTZmoXnHx4hr7" }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary" }),
	      _react2.default.createElement("meta", { name: "twitter:title", content: "Move To Nordics" }),
	      _react2.default.createElement("meta", { name: "twitter:description", content: "Your portal to the best tech ecosystem in the world." }),
	      _react2.default.createElement("meta", { name: "og:title", content: "Move To Nordics" }),
	      _react2.default.createElement("meta", { name: "og:description", content: "Your portal to the best tech ecosystem in the world." }),
	      _react2.default.createElement("meta", { name: "og:image", content: "https://media.graphcms.com/resize=w:1200,fit:crop/output=format:jpg/compress/2Lv82o4zTZmoXnHx4hr7" }),
	      _react2.default.createElement("meta", { name: "og:url", content: "https://movetonordics.com" }),
	      _react2.default.createElement("meta", { name: "og:site_name", content: "Move To Nordics" }),
	      _react2.default.createElement("meta", { name: "og:type", content: "website" }),
	      _react2.default.createElement("link", {
	        href: "https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900|Poppins:700",
	        rel: "stylesheet"
	      })
	    ),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      PageWrapper,
	      null,
	      children()
	    ),
	    _react2.default.createElement(_PartnersBar.PartnersBar, { partners: data.partners.edges }),
	    _react2.default.createElement(_Footer2.default, {
	      aboutMenu: loadAboutMenu(data.aboutMenu.edges),
	      eventTypes: eventTypes(data.events.edges),
	      jobRoles: jobRoles(data.jobs.edges)
	    })
	  );
	};
	
	var AboutMenuQuery = exports.AboutMenuQuery = "** extracted graphql fragment **";
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-4becc6206314fe0ca024.js